// This code implements the `-sMODULARIZE` settings by taking the generated
// JS program code (INNER_JS_CODE) and wrapping it in a factory function.

// When targeting node and ES6 we use `await import ..` in the generated code
// so the outer function needs to be marked as async.
async function createQspModule(moduleArg = {}) {
  var moduleRtn;

  // include: shell.js
  // include: minimum_runtime_check.js
  (function () {
    // "30.0.0" -> 300000
    function humanReadableVersionToPacked(str) {
      str = str.split('-')[0]; // Remove any trailing part from e.g. "12.53.3-alpha"
      var vers = str.split('.').slice(0, 3);
      while (vers.length < 3) vers.push('00');
      vers = vers.map((n, i, arr) => n.padStart(2, '0'));
      return vers.join('');
    }
    // 300000 -> "30.0.0"
    var packedVersionToHumanReadable = (n) =>
      [(n / 10000) | 0, ((n / 100) | 0) % 100, n % 100].join('.');

    var TARGET_NOT_SUPPORTED = 2147483647;

    // Note: We use a typeof check here instead of optional chaining using
    // globalThis because older browsers might not have globalThis defined.
    var currentNodeVersion =
      typeof process !== 'undefined' && process.versions?.node
        ? humanReadableVersionToPacked(process.versions.node)
        : TARGET_NOT_SUPPORTED;
    if (currentNodeVersion < 160000) {
      throw new Error(
        `This emscripten-generated code requires node v${packedVersionToHumanReadable(160000)} (detected v${packedVersionToHumanReadable(currentNodeVersion)})`,
      );
    }

    var userAgent = typeof navigator !== 'undefined' && navigator.userAgent;
    if (!userAgent) {
      return;
    }

    var currentSafariVersion =
      userAgent.includes('Safari/') &&
      !userAgent.includes('Chrome/') &&
      userAgent.match(/Version\/(\d+\.?\d*\.?\d*)/)
        ? humanReadableVersionToPacked(userAgent.match(/Version\/(\d+\.?\d*\.?\d*)/)[1])
        : TARGET_NOT_SUPPORTED;
    if (currentSafariVersion < 150000) {
      throw new Error(
        `This emscripten-generated code requires Safari v${packedVersionToHumanReadable(150000)} (detected v${currentSafariVersion})`,
      );
    }

    var currentFirefoxVersion = userAgent.match(/Firefox\/(\d+(?:\.\d+)?)/)
      ? parseFloat(userAgent.match(/Firefox\/(\d+(?:\.\d+)?)/)[1])
      : TARGET_NOT_SUPPORTED;
    if (currentFirefoxVersion < 79) {
      throw new Error(
        `This emscripten-generated code requires Firefox v79 (detected v${currentFirefoxVersion})`,
      );
    }

    var currentChromeVersion = userAgent.match(/Chrome\/(\d+(?:\.\d+)?)/)
      ? parseFloat(userAgent.match(/Chrome\/(\d+(?:\.\d+)?)/)[1])
      : TARGET_NOT_SUPPORTED;
    if (currentChromeVersion < 85) {
      throw new Error(
        `This emscripten-generated code requires Chrome v85 (detected v${currentChromeVersion})`,
      );
    }
  })();

  // end include: minimum_runtime_check.js
  // The Module object: Our interface to the outside world. We import
  // and export values on it. There are various ways Module can be used:
  // 1. Not defined. We create it here
  // 2. A function parameter, function(moduleArg) => Promise<Module>
  // 3. pre-run appended it, var Module = {}; ..generated code..
  // 4. External script tag defines var Module.
  // We need to check if Module already exists (e.g. case 3 above).
  // Substitution will be replaced with actual code on later stage of the build,
  // this way Closure Compiler will not mangle it (e.g. case 4. above).
  // Note that if you want to run closure, and also to use Module
  // after the generated code, you will need to define   var Module = {};
  // before the code. Then that object will be used in the code, and you
  // can continue to use Module afterwards as well.
  var Module = moduleArg;

  // Determine the runtime environment we are in. You can customize this by
  // setting the ENVIRONMENT setting at compile time (see settings.js).

  // Attempt to auto-detect the environment
  var ENVIRONMENT_IS_WEB = !!globalThis.window;
  var ENVIRONMENT_IS_WORKER = !!globalThis.WorkerGlobalScope;
  // N.b. Electron.js environment is simultaneously a NODE-environment, but
  // also a web environment.
  var ENVIRONMENT_IS_NODE =
    globalThis.process?.versions?.node && globalThis.process?.type != 'renderer';
  var ENVIRONMENT_IS_SHELL = !ENVIRONMENT_IS_WEB && !ENVIRONMENT_IS_NODE && !ENVIRONMENT_IS_WORKER;

  if (ENVIRONMENT_IS_NODE) {
    // When building an ES module `require` is not normally available.
    // We need to use `createRequire()` to construct the require()` function.
    const { createRequire } = await import('node:module');
    /** @suppress{duplicate} */
    var require = createRequire(import.meta.url);
  }

  // --pre-jses are emitted after the Module integration code, so that they can
  // refer to Module (if they choose; they can also define Module)

  var arguments_ = [];
  var thisProgram = './this.program';
  var quit_ = (status, toThrow) => {
    throw toThrow;
  };

  var _scriptName = import.meta.url;

  // `/` should be present at the end if `scriptDirectory` is not empty
  var scriptDirectory = '';
  function locateFile(path) {
    if (Module['locateFile']) {
      return Module['locateFile'](path, scriptDirectory);
    }
    return scriptDirectory + path;
  }

  // Hooks that are implemented differently in different runtime environments.
  var readAsync, readBinary;

  if (ENVIRONMENT_IS_NODE) {
    const isNode = globalThis.process?.versions?.node && globalThis.process?.type != 'renderer';
    if (!isNode)
      throw new Error(
        'not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)',
      );

    // These modules will usually be used on Node.js. Load them eagerly to avoid
    // the complexity of lazy-loading.
    var fs = require('node:fs');

    if (_scriptName.startsWith('file:')) {
      scriptDirectory =
        require('node:path').dirname(require('node:url').fileURLToPath(_scriptName)) + '/';
    }

    // include: node_shell_read.js
    readBinary = (filename) => {
      // We need to re-wrap `file://` strings to URLs.
      filename = isFileURI(filename) ? new URL(filename) : filename;
      var ret = fs.readFileSync(filename);
      assert(Buffer.isBuffer(ret));
      return ret;
    };

    readAsync = async (filename, binary = true) => {
      // See the comment in the `readBinary` function.
      filename = isFileURI(filename) ? new URL(filename) : filename;
      var ret = fs.readFileSync(filename, binary ? undefined : 'utf8');
      assert(binary ? Buffer.isBuffer(ret) : typeof ret == 'string');
      return ret;
    };
    // end include: node_shell_read.js
    if (process.argv.length > 1) {
      thisProgram = process.argv[1].replace(/\\/g, '/');
    }

    arguments_ = process.argv.slice(2);

    quit_ = (status, toThrow) => {
      process.exitCode = status;
      throw toThrow;
    };
  } else if (ENVIRONMENT_IS_SHELL) {
  } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
    // Note that this includes Node.js workers when relevant (pthreads is enabled).
    // Node.js workers are detected as a combination of ENVIRONMENT_IS_WORKER and
    // ENVIRONMENT_IS_NODE.
    try {
      scriptDirectory = new URL('.', _scriptName).href; // includes trailing slash
    } catch {
      // Must be a `blob:` or `data:` URL (e.g. `blob:http://site.com/etc/etc`), we cannot
      // infer anything from them.
    }

    if (!(globalThis.window || globalThis.WorkerGlobalScope))
      throw new Error(
        'not compiled for this environment (did you build to HTML and try to run it not on the web, or set ENVIRONMENT to something - like node - and run it someplace else - like on the web?)',
      );

    {
      // include: web_or_worker_shell_read.js
      if (ENVIRONMENT_IS_WORKER) {
        readBinary = (url) => {
          var xhr = new XMLHttpRequest();
          xhr.open('GET', url, false);
          xhr.responseType = 'arraybuffer';
          xhr.send(null);
          return new Uint8Array(/** @type{!ArrayBuffer} */ (xhr.response));
        };
      }

      readAsync = async (url) => {
        // Fetch has some additional restrictions over XHR, like it can't be used on a file:// url.
        // See https://github.com/github/fetch/pull/92#issuecomment-140665932
        // Cordova or Electron apps are typically loaded from a file:// url.
        // So use XHR on webview if URL is a file URL.
        if (isFileURI(url)) {
          return new Promise((resolve, reject) => {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'arraybuffer';
            xhr.onload = () => {
              if (xhr.status == 200 || (xhr.status == 0 && xhr.response)) {
                // file URLs can return 0
                resolve(xhr.response);
                return;
              }
              reject(xhr.status);
            };
            xhr.onerror = reject;
            xhr.send(null);
          });
        }
        var response = await fetch(url, { credentials: 'same-origin' });
        if (response.ok) {
          return response.arrayBuffer();
        }
        throw new Error(response.status + ' : ' + response.url);
      };
      // end include: web_or_worker_shell_read.js
    }
  } else {
    throw new Error('environment detection error');
  }

  var out = console.log.bind(console);
  var err = console.error.bind(console);

  var IDBFS = 'IDBFS is no longer included by default; build with -lidbfs.js';
  var PROXYFS = 'PROXYFS is no longer included by default; build with -lproxyfs.js';
  var WORKERFS = 'WORKERFS is no longer included by default; build with -lworkerfs.js';
  var FETCHFS = 'FETCHFS is no longer included by default; build with -lfetchfs.js';
  var ICASEFS = 'ICASEFS is no longer included by default; build with -licasefs.js';
  var JSFILEFS = 'JSFILEFS is no longer included by default; build with -ljsfilefs.js';
  var OPFS = 'OPFS is no longer included by default; build with -lopfs.js';

  var NODEFS = 'NODEFS is no longer included by default; build with -lnodefs.js';

  // perform assertions in shell.js after we set up out() and err(), as otherwise
  // if an assertion fails it cannot print the message

  assert(
    !ENVIRONMENT_IS_SHELL,
    'shell environment detected but not enabled at build time.  Add `shell` to `-sENVIRONMENT` to enable.',
  );

  // end include: shell.js

  // include: preamble.js
  // === Preamble library stuff ===

  // Documentation for the public APIs defined in this file must be updated in:
  //    site/source/docs/api_reference/preamble.js.rst
  // A prebuilt local version of the documentation is available at:
  //    site/build/text/docs/api_reference/preamble.js.txt
  // You can also build docs locally as HTML or other formats in site/
  // An online HTML version (which may be of a different version of Emscripten)
  //    is up at http://kripken.github.io/emscripten-site/docs/api_reference/preamble.js.html

  var wasmBinary;

  if (!globalThis.WebAssembly) {
    err('no native wasm support detected');
  }

  // Wasm globals

  //========================================
  // Runtime essentials
  //========================================

  // whether we are quitting the application. no code should run after this.
  // set in exit() and abort()
  var ABORT = false;

  // set by exit() and abort().  Passed to 'onExit' handler.
  // NOTE: This is also used as the process return code in shell environments
  // but only when noExitRuntime is false.
  var EXITSTATUS;

  // In STRICT mode, we only define assert() when ASSERTIONS is set.  i.e. we
  // don't define it at all in release modes.  This matches the behaviour of
  // MINIMAL_RUNTIME.
  // TODO(sbc): Make this the default even without STRICT enabled.
  /** @type {function(*, string=)} */
  function assert(condition, text) {
    if (!condition) {
      abort('Assertion failed' + (text ? ': ' + text : ''));
    }
  }

  // We used to include malloc/free by default in the past. Show a helpful error in
  // builds with assertions.

  /**
   * Indicates whether filename is delivered via file protocol (as opposed to http/https)
   * @noinline
   */
  var isFileURI = (filename) => filename.startsWith('file://');

  // include: runtime_common.js
  // include: runtime_stack_check.js
  // Initializes the stack cookie. Called at the startup of main and at the startup of each thread in pthreads mode.
  function writeStackCookie() {
    var max = _emscripten_stack_get_end();
    assert((max & 3) == 0);
    // If the stack ends at address zero we write our cookies 4 bytes into the
    // stack.  This prevents interference with SAFE_HEAP and ASAN which also
    // monitor writes to address zero.
    if (max == 0) {
      max += 4;
    }
    // The stack grow downwards towards _emscripten_stack_get_end.
    // We write cookies to the final two words in the stack and detect if they are
    // ever overwritten.
    HEAPU32[max >> 2] = 0x02135467;
    HEAPU32[(max + 4) >> 2] = 0x89bacdfe;
    // Also test the global address 0 for integrity.
    HEAPU32[0 >> 2] = 1668509029;
  }

  function checkStackCookie() {
    if (ABORT) return;
    var max = _emscripten_stack_get_end();
    // See writeStackCookie().
    if (max == 0) {
      max += 4;
    }
    var cookie1 = HEAPU32[max >> 2];
    var cookie2 = HEAPU32[(max + 4) >> 2];
    if (cookie1 != 0x02135467 || cookie2 != 0x89bacdfe) {
      abort(
        `Stack overflow! Stack cookie has been overwritten at ${ptrToString(max)}, expected hex dwords 0x89BACDFE and 0x2135467, but received ${ptrToString(cookie2)} ${ptrToString(cookie1)}`,
      );
    }
    // Also test the global address 0 for integrity.
    if (HEAPU32[0 >> 2] != 0x63736d65 /* 'emsc' */) {
      abort('Runtime error: The application has corrupted its heap memory area (address zero)!');
    }
  }
  // end include: runtime_stack_check.js
  // include: runtime_exceptions.js
  // end include: runtime_exceptions.js
  // include: runtime_debug.js
  var runtimeDebug = true; // Switch to false at runtime to disable logging at the right times

  // Used by XXXXX_DEBUG settings to output debug messages.
  function dbg(...args) {
    if (!runtimeDebug && typeof runtimeDebug != 'undefined') return;
    // TODO(sbc): Make this configurable somehow.  Its not always convenient for
    // logging to show up as warnings.
    console.warn(...args);
  }

  // Endianness check
  (() => {
    var h16 = new Int16Array(1);
    var h8 = new Int8Array(h16.buffer);
    h16[0] = 0x6373;
    if (h8[0] !== 0x73 || h8[1] !== 0x63)
      abort(
        'Runtime error: expected the system to be little-endian! (Run with -sSUPPORT_BIG_ENDIAN to bypass)',
      );
  })();

  function consumedModuleProp(prop) {
    if (!Object.getOwnPropertyDescriptor(Module, prop)) {
      Object.defineProperty(Module, prop, {
        configurable: true,
        set() {
          abort(
            `Attempt to set \`Module.${prop}\` after it has already been processed.  This can happen, for example, when code is injected via '--post-js' rather than '--pre-js'`,
          );
        },
      });
    }
  }

  function makeInvalidEarlyAccess(name) {
    return () =>
      assert(false, `call to '${name}' via reference taken before Wasm module initialization`);
  }

  function ignoredModuleProp(prop) {
    if (Object.getOwnPropertyDescriptor(Module, prop)) {
      abort(
        `\`Module.${prop}\` was supplied but \`${prop}\` not included in INCOMING_MODULE_JS_API`,
      );
    }
  }

  // forcing the filesystem exports a few things by default
  function isExportedByForceFilesystem(name) {
    return (
      name === 'FS_createPath' ||
      name === 'FS_createDataFile' ||
      name === 'FS_createPreloadedFile' ||
      name === 'FS_preloadFile' ||
      name === 'FS_unlink' ||
      name === 'addRunDependency' ||
      // The old FS has some functionality that WasmFS lacks.
      name === 'FS_createLazyFile' ||
      name === 'FS_createDevice' ||
      name === 'removeRunDependency'
    );
  }

  function missingLibrarySymbol(sym) {
    // Any symbol that is not included from the JS library is also (by definition)
    // not exported on the Module object.
    unexportedRuntimeSymbol(sym);
  }

  function unexportedRuntimeSymbol(sym) {
    if (!Object.getOwnPropertyDescriptor(Module, sym)) {
      Object.defineProperty(Module, sym, {
        configurable: true,
        get() {
          var msg = `'${sym}' was not exported. add it to EXPORTED_RUNTIME_METHODS (see the Emscripten FAQ)`;
          if (isExportedByForceFilesystem(sym)) {
            msg +=
              '. Alternatively, forcing filesystem support (-sFORCE_FILESYSTEM) can export this for you';
          }
          abort(msg);
        },
      });
    }
  }

  // end include: runtime_debug.js
  var readyPromiseResolve, readyPromiseReject;

  // Memory management
  var /** @type {!Int8Array} */
    HEAP8,
    /** @type {!Uint8Array} */
    HEAPU8,
    /** @type {!Int16Array} */
    HEAP16,
    /** @type {!Uint16Array} */
    HEAPU16,
    /** @type {!Int32Array} */
    HEAP32,
    /** @type {!Uint32Array} */
    HEAPU32,
    /** @type {!Float32Array} */
    HEAPF32,
    /** @type {!Float64Array} */
    HEAPF64;

  // BigInt64Array type is not correctly defined in closure
  var /** not-@type {!BigInt64Array} */
    HEAP64,
    /* BigUint64Array type is not correctly defined in closure
/** not-@type {!BigUint64Array} */
    HEAPU64;

  var runtimeInitialized = false;

  function updateMemoryViews() {
    var b = wasmMemory.buffer;
    Module['HEAP8'] = HEAP8 = new Int8Array(b);
    Module['HEAP16'] = HEAP16 = new Int16Array(b);
    Module['HEAPU8'] = HEAPU8 = new Uint8Array(b);
    Module['HEAPU16'] = HEAPU16 = new Uint16Array(b);
    Module['HEAP32'] = HEAP32 = new Int32Array(b);
    Module['HEAPU32'] = HEAPU32 = new Uint32Array(b);
    Module['HEAPF32'] = HEAPF32 = new Float32Array(b);
    Module['HEAPF64'] = HEAPF64 = new Float64Array(b);
    HEAP64 = new BigInt64Array(b);
    HEAPU64 = new BigUint64Array(b);
  }

  // include: memoryprofiler.js
  // end include: memoryprofiler.js
  // end include: runtime_common.js
  assert(
    globalThis.Int32Array &&
      globalThis.Float64Array &&
      Int32Array.prototype.subarray &&
      Int32Array.prototype.set,
    'JS engine does not provide full typed array support',
  );

  function preRun() {
    if (Module['preRun']) {
      if (typeof Module['preRun'] == 'function') Module['preRun'] = [Module['preRun']];
      while (Module['preRun'].length) {
        addOnPreRun(Module['preRun'].shift());
      }
    }
    consumedModuleProp('preRun');
    // Begin ATPRERUNS hooks
    callRuntimeCallbacks(onPreRuns);
    // End ATPRERUNS hooks
  }

  function initRuntime() {
    assert(!runtimeInitialized);
    runtimeInitialized = true;

    setStackLimits();

    checkStackCookie();

    // No ATINITS hooks

    wasmExports['__wasm_call_ctors']();

    // No ATPOSTCTORS hooks
  }

  function postRun() {
    checkStackCookie();
    // PThreads reuse the runtime from the main thread.

    if (Module['postRun']) {
      if (typeof Module['postRun'] == 'function') Module['postRun'] = [Module['postRun']];
      while (Module['postRun'].length) {
        addOnPostRun(Module['postRun'].shift());
      }
    }
    consumedModuleProp('postRun');

    // Begin ATPOSTRUNS hooks
    callRuntimeCallbacks(onPostRuns);
    // End ATPOSTRUNS hooks
  }

  /** @param {string|number=} what */
  function abort(what) {
    Module['onAbort']?.(what);

    what = 'Aborted(' + what + ')';
    // TODO(sbc): Should we remove printing and leave it up to whoever
    // catches the exception?
    err(what);

    ABORT = true;

    if (what.search(/RuntimeError: [Uu]nreachable/) >= 0) {
      what +=
        '. "unreachable" may be due to ASYNCIFY_STACK_SIZE not being large enough (try increasing it)';
    }

    // Use a wasm runtime error, because a JS error might be seen as a foreign
    // exception, which means we'd run destructors on it. We need the error to
    // simply make the program stop.
    // FIXME This approach does not work in Wasm EH because it currently does not assume
    // all RuntimeErrors are from traps; it decides whether a RuntimeError is from
    // a trap or not based on a hidden field within the object. So at the moment
    // we don't have a way of throwing a wasm trap from JS. TODO Make a JS API that
    // allows this in the wasm spec.

    // Suppress closure compiler warning here. Closure compiler's builtin extern
    // definition for WebAssembly.RuntimeError claims it takes no arguments even
    // though it can.
    // TODO(https://github.com/google/closure-compiler/pull/3913): Remove if/when upstream closure gets fixed.
    /** @suppress {checkTypes} */
    var e = new WebAssembly.RuntimeError(what);

    readyPromiseReject?.(e);
    // Throw the error whether or not MODULARIZE is set because abort is used
    // in code paths apart from instantiation where an exception is expected
    // to be thrown when abort is called.
    throw e;
  }

  // show errors on likely calls to FS when it was not included
  var FS = {
    error() {
      abort(
        'Filesystem support (FS) was not included. The problem is that you are using files from JS, but files were not used from C/C++, so filesystem support was not auto-included. You can force-include filesystem support with -sFORCE_FILESYSTEM',
      );
    },
    init() {
      FS.error();
    },
    createDataFile() {
      FS.error();
    },
    createPreloadedFile() {
      FS.error();
    },
    createLazyFile() {
      FS.error();
    },
    open() {
      FS.error();
    },
    mkdev() {
      FS.error();
    },
    registerDevice() {
      FS.error();
    },
    analyzePath() {
      FS.error();
    },

    ErrnoError() {
      FS.error();
    },
  };

  function createExportWrapper(name, nargs) {
    return (...args) => {
      assert(
        runtimeInitialized,
        `native function \`${name}\` called before runtime initialization`,
      );
      var f = wasmExports[name];
      assert(f, `exported native function \`${name}\` not found`);
      // Only assert for too many arguments. Too few can be valid since the missing arguments will be zero filled.
      assert(
        args.length <= nargs,
        `native function \`${name}\` called with ${args.length} args but expects ${nargs}`,
      );
      return f(...args);
    };
  }

  var wasmBinaryFile;

  function findWasmBinary() {
    if (Module['locateFile']) {
      return locateFile('qsp-engine-debug.wasm');
    }

    // Use bundler-friendly `new URL(..., import.meta.url)` pattern; works in browsers too.
    return new URL('qsp-engine-debug.wasm', import.meta.url).href;
  }

  function getBinarySync(file) {
    if (file == wasmBinaryFile && wasmBinary) {
      return new Uint8Array(wasmBinary);
    }
    if (readBinary) {
      return readBinary(file);
    }
    // Throwing a plain string here, even though it not normally advisable since
    // this gets turning into an `abort` in instantiateArrayBuffer.
    throw 'both async and sync fetching of the wasm failed';
  }

  async function getWasmBinary(binaryFile) {
    // If we don't have the binary yet, load it asynchronously using readAsync.
    if (!wasmBinary) {
      // Fetch the binary using readAsync
      try {
        var response = await readAsync(binaryFile);
        return new Uint8Array(response);
      } catch {
        // Fall back to getBinarySync below;
      }
    }

    // Otherwise, getBinarySync should be able to get it synchronously
    return getBinarySync(binaryFile);
  }

  async function instantiateArrayBuffer(binaryFile, imports) {
    try {
      var binary = await getWasmBinary(binaryFile);
      var instance = await WebAssembly.instantiate(binary, imports);
      return instance;
    } catch (reason) {
      err(`failed to asynchronously prepare wasm: ${reason}`);

      // Warn on some common problems.
      if (isFileURI(binaryFile)) {
        err(
          `warning: Loading from a file URI (${binaryFile}) is not supported in most browsers. See https://emscripten.org/docs/getting_started/FAQ.html#how-do-i-run-a-local-webserver-for-testing-why-does-my-program-stall-in-downloading-or-preparing`,
        );
      }
      abort(reason);
    }
  }

  async function instantiateAsync(binary, binaryFile, imports) {
    if (
      !binary &&
      // Don't use streaming for file:// delivered objects in a webview, fetch them synchronously.
      !isFileURI(binaryFile) &&
      // Avoid instantiateStreaming() on Node.js environment for now, as while
      // Node.js v18.1.0 implements it, it does not have a full fetch()
      // implementation yet.
      //
      // Reference:
      //   https://github.com/emscripten-core/emscripten/pull/16917
      !ENVIRONMENT_IS_NODE
    ) {
      try {
        var response = fetch(binaryFile, { credentials: 'same-origin' });
        var instantiationResult = await WebAssembly.instantiateStreaming(response, imports);
        return instantiationResult;
      } catch (reason) {
        // We expect the most common failure cause to be a bad MIME type for the binary,
        // in which case falling back to ArrayBuffer instantiation should work.
        err(`wasm streaming compile failed: ${reason}`);
        err('falling back to ArrayBuffer instantiation');
        // fall back of instantiateArrayBuffer below
      }
    }
    return instantiateArrayBuffer(binaryFile, imports);
  }

  function getWasmImports() {
    // instrumenting imports is used in asyncify in two ways: to add assertions
    // that check for proper import use, and for JSPI we use them to set up
    // the Promise API on the import side.
    Asyncify.instrumentWasmImports(wasmImports);
    // prepare imports
    var imports = {
      env: wasmImports,
      wasi_snapshot_preview1: wasmImports,
    };
    return imports;
  }

  // Create the wasm instance.
  // Receives the wasm imports, returns the exports.
  async function createWasm() {
    // Load the wasm module and create an instance of using native support in the JS engine.
    // handle a generated wasm instance, receiving its exports and
    // performing other necessary setup
    /** @param {WebAssembly.Module=} module*/
    function receiveInstance(instance, module) {
      wasmExports = instance.exports;

      wasmExports = Asyncify.instrumentWasmExports(wasmExports);

      assignWasmExports(wasmExports);

      updateMemoryViews();

      return wasmExports;
    }

    // Prefer streaming instantiation if available.
    // Async compilation can be confusing when an error on the page overwrites Module
    // (for example, if the order of elements is wrong, and the one defining Module is
    // later), so we save Module and check it later.
    var trueModule = Module;
    function receiveInstantiationResult(result) {
      // 'result' is a ResultObject object which has both the module and instance.
      // receiveInstance() will swap in the exports (to Module.asm) so they can be called
      assert(
        Module === trueModule,
        'the Module object should not be replaced during async compilation - perhaps the order of HTML elements is wrong?',
      );
      trueModule = null;
      // TODO: Due to Closure regression https://github.com/google/closure-compiler/issues/3193, the above line no longer optimizes out down to the following line.
      // When the regression is fixed, can restore the above PTHREADS-enabled path.
      return receiveInstance(result['instance']);
    }

    var info = getWasmImports();

    // User shell pages can write their own Module.instantiateWasm = function(imports, successCallback) callback
    // to manually instantiate the Wasm module themselves. This allows pages to
    // run the instantiation parallel to any other async startup actions they are
    // performing.
    // Also pthreads and wasm workers initialize the wasm instance through this
    // path.
    if (Module['instantiateWasm']) {
      return new Promise((resolve, reject) => {
        try {
          Module['instantiateWasm'](info, (inst, mod) => {
            resolve(receiveInstance(inst, mod));
          });
        } catch (e) {
          err(`Module.instantiateWasm callback failed with error: ${e}`);
          reject(e);
        }
      });
    }

    wasmBinaryFile ??= findWasmBinary();
    var result = await instantiateAsync(wasmBinary, wasmBinaryFile, info);
    var exports = receiveInstantiationResult(result);
    return exports;
  }

  // end include: preamble.js

  // Begin JS library code

  class ExitStatus {
    name = 'ExitStatus';
    constructor(status) {
      this.message = `Program terminated with exit(${status})`;
      this.status = status;
    }
  }

  var callRuntimeCallbacks = (callbacks) => {
    while (callbacks.length > 0) {
      // Pass the module as the first argument.
      callbacks.shift()(Module);
    }
  };
  var onPostRuns = [];
  var addOnPostRun = (cb) => onPostRuns.push(cb);

  var onPreRuns = [];
  var addOnPreRun = (cb) => onPreRuns.push(cb);

  var dynCalls = {};
  var dynCallLegacy = (sig, ptr, args) => {
    sig = sig.replace(/p/g, 'i');
    assert(sig in dynCalls, `bad function pointer type - sig is not in dynCalls: '${sig}'`);
    if (args?.length) {
      // j (64-bit integer) is fine, and is implemented as a BigInt. Without
      // legalization, the number of parameters should match (j is not expanded
      // into two i's).
      assert(args.length === sig.length - 1);
    } else {
      assert(sig.length == 1);
    }
    var f = dynCalls[sig];
    return f(ptr, ...args);
  };
  var dynCall = (sig, ptr, args = [], promising = false) => {
    assert(ptr, `null function pointer in dynCall`);
    assert(!promising, 'async dynCall is not supported in this mode');
    var rtn = dynCallLegacy(sig, ptr, args);

    function convert(rtn) {
      return rtn;
    }

    return convert(rtn);
  };

  /**
   * @param {number} ptr
   * @param {string} type
   */
  function getValue(ptr, type = 'i8') {
    if (type.endsWith('*')) type = '*';
    switch (type) {
      case 'i1':
        return HEAP8[ptr];
      case 'i8':
        return HEAP8[ptr];
      case 'i16':
        return HEAP16[ptr >> 1];
      case 'i32':
        return HEAP32[ptr >> 2];
      case 'i64':
        return HEAP64[ptr >> 3];
      case 'float':
        return HEAPF32[ptr >> 2];
      case 'double':
        return HEAPF64[ptr >> 3];
      case '*':
        return HEAPU32[ptr >> 2];
      default:
        abort(`invalid type for getValue: ${type}`);
    }
  }

  var noExitRuntime = true;

  var ptrToString = (ptr) => {
    assert(typeof ptr === 'number', `ptrToString expects a number, got ${typeof ptr}`);
    // Convert to 32-bit unsigned value
    ptr >>>= 0;
    return '0x' + ptr.toString(16).padStart(8, '0');
  };

  var setStackLimits = () => {
    var stackLow = _emscripten_stack_get_base();
    var stackHigh = _emscripten_stack_get_end();
    ___set_stack_limits(stackLow, stackHigh);
  };

  /**
   * @param {number} ptr
   * @param {number} value
   * @param {string} type
   */
  function setValue(ptr, value, type = 'i8') {
    if (type.endsWith('*')) type = '*';
    switch (type) {
      case 'i1':
        HEAP8[ptr] = value;
        break;
      case 'i8':
        HEAP8[ptr] = value;
        break;
      case 'i16':
        HEAP16[ptr >> 1] = value;
        break;
      case 'i32':
        HEAP32[ptr >> 2] = value;
        break;
      case 'i64':
        HEAP64[ptr >> 3] = BigInt(value);
        break;
      case 'float':
        HEAPF32[ptr >> 2] = value;
        break;
      case 'double':
        HEAPF64[ptr >> 3] = value;
        break;
      case '*':
        HEAPU32[ptr >> 2] = value;
        break;
      default:
        abort(`invalid type for setValue: ${type}`);
    }
  }

  var stackRestore = (val) => __emscripten_stack_restore(val);

  var stackSave = () => _emscripten_stack_get_current();

  var warnOnce = (text) => {
    warnOnce.shown ||= {};
    if (!warnOnce.shown[text]) {
      warnOnce.shown[text] = 1;
      if (ENVIRONMENT_IS_NODE) text = 'warning: ' + text;
      err(text);
    }
  };

  var ___handle_stack_overflow = (requested) => {
    var base = _emscripten_stack_get_base();
    var end = _emscripten_stack_get_end();
    abort(
      `stack overflow (Attempt to set SP to ${ptrToString(requested)}` +
        `, with stack limits [${ptrToString(end)} - ${ptrToString(base)}` +
        ']). If you require more stack space build with -sSTACK_SIZE=<bytes>',
    );
  };

  var __abort_js = () => abort('native code called abort()');

  var _emscripten_date_now = () => Date.now();

  var getHeapMax = () =>
    // Stay one Wasm page short of 4GB: while e.g. Chrome is able to allocate
    // full 4GB Wasm memories, the size will wrap back to 0 bytes in Wasm side
    // for any code that deals with heap sizes, which would require special
    // casing all heap size related code to treat 0 specially.
    2147483648;

  var alignMemory = (size, alignment) => {
    assert(alignment, 'alignment argument is required');
    return Math.ceil(size / alignment) * alignment;
  };

  var growMemory = (size) => {
    var oldHeapSize = wasmMemory.buffer.byteLength;
    var pages = ((size - oldHeapSize + 65535) / 65536) | 0;
    try {
      // round size grow request up to wasm page size (fixed 64KB per spec)
      wasmMemory.grow(pages); // .grow() takes a delta compared to the previous size
      updateMemoryViews();
      return 1 /*success*/;
    } catch (e) {
      err(
        `growMemory: Attempted to grow heap from ${oldHeapSize} bytes to ${size} bytes, but got error: ${e}`,
      );
    }
    // implicit 0 return to save code size (caller will cast "undefined" into 0
    // anyhow)
  };
  var _emscripten_resize_heap = (requestedSize) => {
    var oldSize = HEAPU8.length;
    // With CAN_ADDRESS_2GB or MEMORY64, pointers are already unsigned.
    requestedSize >>>= 0;
    // With multithreaded builds, races can happen (another thread might increase the size
    // in between), so return a failure, and let the caller retry.
    assert(requestedSize > oldSize);

    // Memory resize rules:
    // 1.  Always increase heap size to at least the requested size, rounded up
    //     to next page multiple.
    // 2a. If MEMORY_GROWTH_LINEAR_STEP == -1, excessively resize the heap
    //     geometrically: increase the heap size according to
    //     MEMORY_GROWTH_GEOMETRIC_STEP factor (default +20%), At most
    //     overreserve by MEMORY_GROWTH_GEOMETRIC_CAP bytes (default 96MB).
    // 2b. If MEMORY_GROWTH_LINEAR_STEP != -1, excessively resize the heap
    //     linearly: increase the heap size by at least
    //     MEMORY_GROWTH_LINEAR_STEP bytes.
    // 3.  Max size for the heap is capped at 2048MB-WASM_PAGE_SIZE, or by
    //     MAXIMUM_MEMORY, or by ASAN limit, depending on which is smallest
    // 4.  If we were unable to allocate as much memory, it may be due to
    //     over-eager decision to excessively reserve due to (3) above.
    //     Hence if an allocation fails, cut down on the amount of excess
    //     growth, in an attempt to succeed to perform a smaller allocation.

    // A limit is set for how much we can grow. We should not exceed that
    // (the wasm binary specifies it, so if we tried, we'd fail anyhow).
    var maxHeapSize = getHeapMax();
    if (requestedSize > maxHeapSize) {
      err(
        `Cannot enlarge memory, requested ${requestedSize} bytes, but the limit is ${maxHeapSize} bytes!`,
      );
      return false;
    }

    // Loop through potential heap size increases. If we attempt a too eager
    // reservation that fails, cut down on the attempted size and reserve a
    // smaller bump instead. (max 3 times, chosen somewhat arbitrarily)
    for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
      var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown); // ensure geometric growth
      // but limit overreserving (default to capping at +96MB overgrowth at most)
      overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);

      var newSize = Math.min(
        maxHeapSize,
        alignMemory(Math.max(requestedSize, overGrownHeapSize), 65536),
      );

      var replacement = growMemory(newSize);
      if (replacement) {
        return true;
      }
    }
    err(`Failed to grow the heap from ${oldSize} bytes to ${newSize} bytes, not enough memory!`);
    return false;
  };

  var ENV = {};

  var getExecutableName = () => thisProgram || './this.program';
  var getEnvStrings = () => {
    if (!getEnvStrings.strings) {
      // Default values.
      // Browser language detection #8751
      var lang = (globalThis.navigator?.language ?? 'C').replace('-', '_') + '.UTF-8';
      var env = {
        USER: 'web_user',
        LOGNAME: 'web_user',
        PATH: '/',
        PWD: '/',
        HOME: '/home/web_user',
        LANG: lang,
        _: getExecutableName(),
      };
      // Apply the user-provided values, if any.
      for (var x in ENV) {
        // x is a key in ENV; if ENV[x] is undefined, that means it was
        // explicitly set to be so. We allow user code to do that to
        // force variables with default values to remain unset.
        if (ENV[x] === undefined) delete env[x];
        else env[x] = ENV[x];
      }
      var strings = [];
      for (var x in env) {
        strings.push(`${x}=${env[x]}`);
      }
      getEnvStrings.strings = strings;
    }
    return getEnvStrings.strings;
  };

  var stringToUTF8Array = (str, heap, outIdx, maxBytesToWrite) => {
    assert(typeof str === 'string', `stringToUTF8Array expects a string (got ${typeof str})`);
    // Parameter maxBytesToWrite is not optional. Negative values, 0, null,
    // undefined and false each don't write out any bytes.
    if (!(maxBytesToWrite > 0)) return 0;

    var startIdx = outIdx;
    var endIdx = outIdx + maxBytesToWrite - 1; // -1 for string null terminator.
    for (var i = 0; i < str.length; ++i) {
      // For UTF8 byte structure, see http://en.wikipedia.org/wiki/UTF-8#Description
      // and https://www.ietf.org/rfc/rfc2279.txt
      // and https://tools.ietf.org/html/rfc3629
      var u = str.codePointAt(i);
      if (u <= 0x7f) {
        if (outIdx >= endIdx) break;
        heap[outIdx++] = u;
      } else if (u <= 0x7ff) {
        if (outIdx + 1 >= endIdx) break;
        heap[outIdx++] = 0xc0 | (u >> 6);
        heap[outIdx++] = 0x80 | (u & 63);
      } else if (u <= 0xffff) {
        if (outIdx + 2 >= endIdx) break;
        heap[outIdx++] = 0xe0 | (u >> 12);
        heap[outIdx++] = 0x80 | ((u >> 6) & 63);
        heap[outIdx++] = 0x80 | (u & 63);
      } else {
        if (outIdx + 3 >= endIdx) break;
        if (u > 0x10ffff)
          warnOnce(
            'Invalid Unicode code point ' +
              ptrToString(u) +
              ' encountered when serializing a JS string to a UTF-8 string in wasm memory! (Valid unicode code points should be in range 0-0x10FFFF).',
          );
        heap[outIdx++] = 0xf0 | (u >> 18);
        heap[outIdx++] = 0x80 | ((u >> 12) & 63);
        heap[outIdx++] = 0x80 | ((u >> 6) & 63);
        heap[outIdx++] = 0x80 | (u & 63);
        // Gotcha: if codePoint is over 0xFFFF, it is represented as a surrogate pair in UTF-16.
        // We need to manually skip over the second code unit for correct iteration.
        i++;
      }
    }
    // Null-terminate the pointer to the buffer.
    heap[outIdx] = 0;
    return outIdx - startIdx;
  };
  var stringToUTF8 = (str, outPtr, maxBytesToWrite) => {
    assert(
      typeof maxBytesToWrite == 'number',
      'stringToUTF8(str, outPtr, maxBytesToWrite) is missing the third parameter that specifies the length of the output buffer!',
    );
    return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
  };
  var _environ_get = (__environ, environ_buf) => {
    var bufSize = 0;
    var envp = 0;
    for (var string of getEnvStrings()) {
      var ptr = environ_buf + bufSize;
      HEAPU32[(__environ + envp) >> 2] = ptr;
      bufSize += stringToUTF8(string, ptr, Infinity) + 1;
      envp += 4;
    }
    return 0;
  };

  var lengthBytesUTF8 = (str) => {
    var len = 0;
    for (var i = 0; i < str.length; ++i) {
      // Gotcha: charCodeAt returns a 16-bit word that is a UTF-16 encoded code
      // unit, not a Unicode code point of the character! So decode
      // UTF16->UTF32->UTF8.
      // See http://unicode.org/faq/utf_bom.html#utf16-3
      var c = str.charCodeAt(i); // possibly a lead surrogate
      if (c <= 0x7f) {
        len++;
      } else if (c <= 0x7ff) {
        len += 2;
      } else if (c >= 0xd800 && c <= 0xdfff) {
        len += 4;
        ++i;
      } else {
        len += 3;
      }
    }
    return len;
  };
  var _environ_sizes_get = (penviron_count, penviron_buf_size) => {
    var strings = getEnvStrings();
    HEAPU32[penviron_count >> 2] = strings.length;
    var bufSize = 0;
    for (var string of strings) {
      bufSize += lengthBytesUTF8(string) + 1;
    }
    HEAPU32[penviron_buf_size >> 2] = bufSize;
    return 0;
  };

  var UTF8Decoder = globalThis.TextDecoder && new TextDecoder();

  var findStringEnd = (heapOrArray, idx, maxBytesToRead, ignoreNul) => {
    var maxIdx = idx + maxBytesToRead;
    if (ignoreNul) return maxIdx;
    // TextDecoder needs to know the byte length in advance, it doesn't stop on
    // null terminator by itself.
    // As a tiny code save trick, compare idx against maxIdx using a negation,
    // so that maxBytesToRead=undefined/NaN means Infinity.
    while (heapOrArray[idx] && !(idx >= maxIdx)) ++idx;
    return idx;
  };

  /**
   * Given a pointer 'idx' to a null-terminated UTF8-encoded string in the given
   * array that contains uint8 values, returns a copy of that string as a
   * Javascript String object.
   * heapOrArray is either a regular array, or a JavaScript typed array view.
   * @param {number=} idx
   * @param {number=} maxBytesToRead
   * @param {boolean=} ignoreNul - If true, the function will not stop on a NUL character.
   * @return {string}
   */
  var UTF8ArrayToString = (heapOrArray, idx = 0, maxBytesToRead, ignoreNul) => {
    var endPtr = findStringEnd(heapOrArray, idx, maxBytesToRead, ignoreNul);

    // When using conditional TextDecoder, skip it for short strings as the overhead of the native call is not worth it.
    if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
      return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
    }
    var str = '';
    while (idx < endPtr) {
      // For UTF8 byte structure, see:
      // http://en.wikipedia.org/wiki/UTF-8#Description
      // https://www.ietf.org/rfc/rfc2279.txt
      // https://tools.ietf.org/html/rfc3629
      var u0 = heapOrArray[idx++];
      if (!(u0 & 0x80)) {
        str += String.fromCharCode(u0);
        continue;
      }
      var u1 = heapOrArray[idx++] & 63;
      if ((u0 & 0xe0) == 0xc0) {
        str += String.fromCharCode(((u0 & 31) << 6) | u1);
        continue;
      }
      var u2 = heapOrArray[idx++] & 63;
      if ((u0 & 0xf0) == 0xe0) {
        u0 = ((u0 & 15) << 12) | (u1 << 6) | u2;
      } else {
        if ((u0 & 0xf8) != 0xf0)
          warnOnce(
            'Invalid UTF-8 leading byte ' +
              ptrToString(u0) +
              ' encountered when deserializing a UTF-8 string in wasm memory to a JS string!',
          );
        u0 = ((u0 & 7) << 18) | (u1 << 12) | (u2 << 6) | (heapOrArray[idx++] & 63);
      }

      if (u0 < 0x10000) {
        str += String.fromCharCode(u0);
      } else {
        var ch = u0 - 0x10000;
        str += String.fromCharCode(0xd800 | (ch >> 10), 0xdc00 | (ch & 0x3ff));
      }
    }
    return str;
  };

  /**
   * Given a pointer 'ptr' to a null-terminated UTF8-encoded string in the
   * emscripten HEAP, returns a copy of that string as a Javascript String object.
   *
   * @param {number} ptr
   * @param {number=} maxBytesToRead - An optional length that specifies the
   *   maximum number of bytes to read. You can omit this parameter to scan the
   *   string until the first 0 byte. If maxBytesToRead is passed, and the string
   *   at [ptr, ptr+maxBytesToReadr[ contains a null byte in the middle, then the
   *   string will cut short at that byte index.
   * @param {boolean=} ignoreNul - If true, the function will not stop on a NUL character.
   * @return {string}
   */
  var UTF8ToString = (ptr, maxBytesToRead, ignoreNul) => {
    assert(typeof ptr == 'number', `UTF8ToString expects a number (got ${typeof ptr})`);
    return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead, ignoreNul) : '';
  };
  var SYSCALLS = {
    varargs: undefined,
    getStr(ptr) {
      var ret = UTF8ToString(ptr);
      return ret;
    },
  };
  var _fd_close = (fd) => {
    abort('fd_close called without SYSCALLS_REQUIRE_FILESYSTEM');
  };

  var INT53_MAX = 9007199254740992;

  var INT53_MIN = -9007199254740992;
  var bigintToI53Checked = (num) => (num < INT53_MIN || num > INT53_MAX ? NaN : Number(num));
  function _fd_seek(fd, offset, whence, newOffset) {
    offset = bigintToI53Checked(offset);

    return 70;
  }

  var printCharBuffers = [null, [], []];

  var printChar = (stream, curr) => {
    var buffer = printCharBuffers[stream];
    assert(buffer);
    if (curr === 0 || curr === 10) {
      (stream === 1 ? out : err)(UTF8ArrayToString(buffer));
      buffer.length = 0;
    } else {
      buffer.push(curr);
    }
  };

  var flush_NO_FILESYSTEM = () => {
    // flush anything remaining in the buffers during shutdown
    _fflush(0);
    if (printCharBuffers[1].length) printChar(1, 10);
    if (printCharBuffers[2].length) printChar(2, 10);
  };

  var _fd_write = (fd, iov, iovcnt, pnum) => {
    // hack to support printf in SYSCALLS_REQUIRE_FILESYSTEM=0
    var num = 0;
    for (var i = 0; i < iovcnt; i++) {
      var ptr = HEAPU32[iov >> 2];
      var len = HEAPU32[(iov + 4) >> 2];
      iov += 8;
      for (var j = 0; j < len; j++) {
        printChar(fd, HEAPU8[ptr + j]);
      }
      num += len;
    }
    HEAPU32[pnum >> 2] = num;
    return 0;
  };

  var runAndAbortIfError = (func) => {
    try {
      return func();
    } catch (e) {
      abort(e);
    }
  };

  var handleException = (e) => {
    // Certain exception types we do not treat as errors since they are used for
    // internal control flow.
    // 1. ExitStatus, which is thrown by exit()
    // 2. "unwind", which is thrown by emscripten_unwind_to_js_event_loop() and others
    //    that wish to return to JS event loop.
    if (e instanceof ExitStatus || e == 'unwind') {
      return EXITSTATUS;
    }
    checkStackCookie();
    if (e instanceof WebAssembly.RuntimeError) {
      if (_emscripten_stack_get_current() <= 0) {
        err(
          'Stack overflow detected.  You can try increasing -sSTACK_SIZE (currently set to 5242880)',
        );
      }
    }
    quit_(1, e);
  };

  var runtimeKeepaliveCounter = 0;
  var keepRuntimeAlive = () => noExitRuntime || runtimeKeepaliveCounter > 0;
  var _proc_exit = (code) => {
    EXITSTATUS = code;
    if (!keepRuntimeAlive()) {
      Module['onExit']?.(code);
      ABORT = true;
    }
    quit_(code, new ExitStatus(code));
  };

  /** @param {boolean|number=} implicit */
  var exitJS = (status, implicit) => {
    EXITSTATUS = status;

    checkUnflushedContent();

    // if exit() was called explicitly, warn the user if the runtime isn't actually being shut down
    if (keepRuntimeAlive() && !implicit) {
      var msg = `program exited (with status: ${status}), but keepRuntimeAlive() is set (counter=${runtimeKeepaliveCounter}) due to an async operation, so halting execution but not exiting the runtime or preventing further async execution (you can use emscripten_force_exit, if you want to force a true shutdown)`;
      readyPromiseReject?.(msg);
      err(msg);
    }

    _proc_exit(status);
  };
  var _exit = exitJS;

  var maybeExit = () => {
    if (!keepRuntimeAlive()) {
      try {
        _exit(EXITSTATUS);
      } catch (e) {
        handleException(e);
      }
    }
  };
  var callUserCallback = (func) => {
    if (ABORT) {
      err('user callback triggered after runtime exited or application aborted.  Ignoring.');
      return;
    }
    try {
      return func();
    } catch (e) {
      handleException(e);
    } finally {
      maybeExit();
    }
  };

  var createNamedFunction = (name, func) => Object.defineProperty(func, 'name', { value: name });

  var runtimeKeepalivePush = () => {
    runtimeKeepaliveCounter += 1;
  };

  var runtimeKeepalivePop = () => {
    assert(runtimeKeepaliveCounter > 0);
    runtimeKeepaliveCounter -= 1;
  };

  var Asyncify = {
    instrumentWasmImports(imports) {
      var importPattern = /^(invoke_.*|__asyncjs__.*)$/;

      for (let [x, original] of Object.entries(imports)) {
        if (typeof original == 'function') {
          let isAsyncifyImport = original.isAsync || importPattern.test(x);
          imports[x] = (...args) => {
            var originalAsyncifyState = Asyncify.state;
            try {
              return original(...args);
            } finally {
              // Only asyncify-declared imports are allowed to change the
              // state.
              // Changing the state from normal to disabled is allowed (in any
              // function) as that is what shutdown does (and we don't have an
              // explicit list of shutdown imports).
              var changedToDisabled =
                originalAsyncifyState === Asyncify.State.Normal &&
                Asyncify.state === Asyncify.State.Disabled;
              // invoke_* functions are allowed to change the state if we do
              // not ignore indirect calls.
              var ignoredInvoke = x.startsWith('invoke_') && true;
              if (
                Asyncify.state !== originalAsyncifyState &&
                !isAsyncifyImport &&
                !changedToDisabled &&
                !ignoredInvoke
              ) {
                abort(`import ${x} was not in ASYNCIFY_IMPORTS, but changed the state`);
              }
            }
          };
        }
      }
    },
    instrumentFunction(original) {
      var wrapper = (...args) => {
        Asyncify.exportCallStack.push(original);
        try {
          return original(...args);
        } finally {
          if (!ABORT) {
            var top = Asyncify.exportCallStack.pop();
            assert(top === original);
            Asyncify.maybeStopUnwind();
          }
        }
      };
      Asyncify.funcWrappers.set(original, wrapper);
      wrapper = createNamedFunction(`__asyncify_wrapper_${original.name}`, wrapper);
      return wrapper;
    },
    instrumentWasmExports(exports) {
      var ret = {};
      for (let [x, original] of Object.entries(exports)) {
        if (typeof original == 'function') {
          var wrapper = Asyncify.instrumentFunction(original);
          ret[x] = wrapper;
        } else {
          ret[x] = original;
        }
      }
      return ret;
    },
    State: {
      Normal: 0,
      Unwinding: 1,
      Rewinding: 2,
      Disabled: 3,
    },
    state: 0,
    StackSize: 16384,
    currData: null,
    handleSleepReturnValue: 0,
    exportCallStack: [],
    callstackFuncToId: new Map(),
    callStackIdToFunc: new Map(),
    funcWrappers: new Map(),
    callStackId: 0,
    asyncPromiseHandlers: null,
    sleepCallbacks: [],
    getCallStackId(func) {
      assert(func);
      if (!Asyncify.callstackFuncToId.has(func)) {
        var id = Asyncify.callStackId++;
        Asyncify.callstackFuncToId.set(func, id);
        Asyncify.callStackIdToFunc.set(id, func);
      }
      return Asyncify.callstackFuncToId.get(func);
    },
    maybeStopUnwind() {
      if (
        Asyncify.currData &&
        Asyncify.state === Asyncify.State.Unwinding &&
        Asyncify.exportCallStack.length === 0
      ) {
        // We just finished unwinding.
        // Be sure to set the state before calling any other functions to avoid
        // possible infinite recursion here (For example in debug pthread builds
        // the dbg() function itself can call back into WebAssembly to get the
        // current pthread_self() pointer).
        Asyncify.state = Asyncify.State.Normal;

        // Keep the runtime alive so that a re-wind can be done later.
        runAndAbortIfError(_asyncify_stop_unwind);
        if (typeof Fibers != 'undefined') {
          Fibers.trampoline();
        }
      }
    },
    whenDone() {
      assert(Asyncify.currData, 'Tried to wait for an async operation when none is in progress.');
      assert(
        !Asyncify.asyncPromiseHandlers,
        'Cannot have multiple async operations in flight at once',
      );
      return new Promise((resolve, reject) => {
        Asyncify.asyncPromiseHandlers = { resolve, reject };
      });
    },
    allocateData() {
      // An asyncify data structure has three fields:
      //  0  current stack pos
      //  4  max stack pos
      //  8  id of function at bottom of the call stack (callStackIdToFunc[id] == wasm func)
      //
      // The Asyncify ABI only interprets the first two fields, the rest is for the runtime.
      // We also embed a stack in the same memory region here, right next to the structure.
      // This struct is also defined as asyncify_data_t in emscripten/fiber.h
      var ptr = _malloc(12 + Asyncify.StackSize);
      Asyncify.setDataHeader(ptr, ptr + 12, Asyncify.StackSize);
      Asyncify.setDataRewindFunc(ptr);
      return ptr;
    },
    setDataHeader(ptr, stack, stackSize) {
      HEAPU32[ptr >> 2] = stack;
      HEAPU32[(ptr + 4) >> 2] = stack + stackSize;
    },
    setDataRewindFunc(ptr) {
      var bottomOfCallStack = Asyncify.exportCallStack[0];
      assert(bottomOfCallStack, 'exportCallStack is empty');
      var rewindId = Asyncify.getCallStackId(bottomOfCallStack);
      HEAP32[(ptr + 8) >> 2] = rewindId;
    },
    getDataRewindFunc(ptr) {
      var id = HEAP32[(ptr + 8) >> 2];
      var func = Asyncify.callStackIdToFunc.get(id);
      assert(func, `id ${id} not found in callStackIdToFunc`);
      return func;
    },
    doRewind(ptr) {
      var original = Asyncify.getDataRewindFunc(ptr);
      var func = Asyncify.funcWrappers.get(original);
      assert(original);
      assert(func);
      // Once we have rewound and the stack we no longer need to artificially
      // keep the runtime alive.

      return callUserCallback(func);
    },
    handleSleep(startAsync) {
      assert(
        Asyncify.state !== Asyncify.State.Disabled,
        'Asyncify cannot be done during or after the runtime exits',
      );
      if (ABORT) return;
      if (Asyncify.state === Asyncify.State.Normal) {
        // Prepare to sleep. Call startAsync, and see what happens:
        // if the code decided to call our callback synchronously,
        // then no async operation was in fact begun, and we don't
        // need to do anything.
        var reachedCallback = false;
        var reachedAfterCallback = false;
        startAsync((handleSleepReturnValue = 0) => {
          // old emterpretify API supported other stuff
          assert(
            ['undefined', 'number', 'boolean', 'bigint'].includes(typeof handleSleepReturnValue),
            `invalid type for handleSleepReturnValue: '${typeof handleSleepReturnValue}'`,
          );
          if (ABORT) return;
          Asyncify.handleSleepReturnValue = handleSleepReturnValue;
          reachedCallback = true;
          if (!reachedAfterCallback) {
            // We are happening synchronously, so no need for async.
            return;
          }
          // This async operation did not happen synchronously, so we did
          // unwind. In that case there can be no compiled code on the stack,
          // as it might break later operations (we can rewind ok now, but if
          // we unwind again, we would unwind through the extra compiled code
          // too).
          assert(
            !Asyncify.exportCallStack.length,
            'Waking up (starting to rewind) must be done from JS, without compiled code on the stack.',
          );
          Asyncify.state = Asyncify.State.Rewinding;
          runAndAbortIfError(() => _asyncify_start_rewind(Asyncify.currData));
          if (typeof MainLoop != 'undefined' && MainLoop.func) {
            MainLoop.resume();
          }
          var asyncWasmReturnValue,
            isError = false;
          try {
            asyncWasmReturnValue = Asyncify.doRewind(Asyncify.currData);
          } catch (err) {
            asyncWasmReturnValue = err;
            isError = true;
          }
          // Track whether the return value was handled by any promise handlers.
          var handled = false;
          if (!Asyncify.currData) {
            // All asynchronous execution has finished.
            // `asyncWasmReturnValue` now contains the final
            // return value of the exported async WASM function.
            //
            // Note: `asyncWasmReturnValue` is distinct from
            // `Asyncify.handleSleepReturnValue`.
            // `Asyncify.handleSleepReturnValue` contains the return
            // value of the last C function to have executed
            // `Asyncify.handleSleep()`, whereas `asyncWasmReturnValue`
            // contains the return value of the exported WASM function
            // that may have called C functions that
            // call `Asyncify.handleSleep()`.
            var asyncPromiseHandlers = Asyncify.asyncPromiseHandlers;
            if (asyncPromiseHandlers) {
              Asyncify.asyncPromiseHandlers = null;
              (isError ? asyncPromiseHandlers.reject : asyncPromiseHandlers.resolve)(
                asyncWasmReturnValue,
              );
              handled = true;
            }
          }
          if (isError && !handled) {
            // If there was an error and it was not handled by now, we have no choice but to
            // rethrow that error into the global scope where it can be caught only by
            // `onerror` or `onunhandledpromiserejection`.
            throw asyncWasmReturnValue;
          }
        });
        reachedAfterCallback = true;
        if (!reachedCallback) {
          // A true async operation was begun; start a sleep.
          Asyncify.state = Asyncify.State.Unwinding;
          // TODO: reuse, don't alloc/free every sleep
          Asyncify.currData = Asyncify.allocateData();
          if (typeof MainLoop != 'undefined' && MainLoop.func) {
            MainLoop.pause();
          }
          runAndAbortIfError(() => _asyncify_start_unwind(Asyncify.currData));
        }
      } else if (Asyncify.state === Asyncify.State.Rewinding) {
        // Stop a resume.
        Asyncify.state = Asyncify.State.Normal;
        runAndAbortIfError(_asyncify_stop_rewind);
        _free(Asyncify.currData);
        Asyncify.currData = null;
        // Call all sleep callbacks now that the sleep-resume is all done.
        Asyncify.sleepCallbacks.forEach(callUserCallback);
      } else {
        abort(`invalid state: ${Asyncify.state}`);
      }
      return Asyncify.handleSleepReturnValue;
    },
    handleAsync: (startAsync) =>
      Asyncify.handleSleep(async (wakeUp) => {
        // TODO: add error handling as a second param when handleSleep implements it.
        wakeUp(await startAsync());
      }),
  };

  var wasmTableMirror = [];

  var getWasmTableEntry = (funcPtr) => {
    var func = wasmTableMirror[funcPtr];
    if (!func) {
      /** @suppress {checkTypes} */
      wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
    }
    /** @suppress {checkTypes} */
    assert(
      wasmTable.get(funcPtr) == func,
      'JavaScript-side Wasm function table mirror is out of date!',
    );
    return func;
  };

  var updateTableMap = (offset, count) => {
    if (functionsInTableMap) {
      for (var i = offset; i < offset + count; i++) {
        var item = getWasmTableEntry(i);
        // Ignore null values.
        if (item) {
          functionsInTableMap.set(item, i);
        }
      }
    }
  };

  var functionsInTableMap;

  var getFunctionAddress = (func) => {
    // First, create the map if this is the first use.
    if (!functionsInTableMap) {
      functionsInTableMap = new WeakMap();
      updateTableMap(0, wasmTable.length);
    }
    return functionsInTableMap.get(func) || 0;
  };

  var freeTableIndexes = [];

  var getEmptyTableSlot = () => {
    // Reuse a free index if there is one, otherwise grow.
    if (freeTableIndexes.length) {
      return freeTableIndexes.pop();
    }
    try {
      // Grow the table
      return wasmTable['grow'](1);
    } catch (err) {
      if (!(err instanceof RangeError)) {
        throw err;
      }
      abort('Unable to grow wasm table. Set ALLOW_TABLE_GROWTH.');
    }
  };

  var setWasmTableEntry = (idx, func) => {
    /** @suppress {checkTypes} */
    wasmTable.set(idx, func);
    // With ABORT_ON_WASM_EXCEPTIONS wasmTable.get is overridden to return wrapped
    // functions so we need to call it here to retrieve the potential wrapper correctly
    // instead of just storing 'func' directly into wasmTableMirror
    /** @suppress {checkTypes} */
    wasmTableMirror[idx] = wasmTable.get(idx);
  };

  var uleb128EncodeWithLen = (arr) => {
    const n = arr.length;
    assert(n < 16384);
    // Note: this LEB128 length encoding produces extra byte for n < 128,
    // but we don't care as it's only used in a temporary representation.
    return [(n % 128) | 128, n >> 7, ...arr];
  };

  var wasmTypeCodes = {
    i: 0x7f, // i32
    p: 0x7f, // i32
    j: 0x7e, // i64
    f: 0x7d, // f32
    d: 0x7c, // f64
    e: 0x6f, // externref
  };
  var generateTypePack = (types) =>
    uleb128EncodeWithLen(
      Array.from(types, (type) => {
        var code = wasmTypeCodes[type];
        assert(code, `invalid signature char: ${type}`);
        return code;
      }),
    );
  var convertJsFunctionToWasm = (func, sig) => {
    // Rest of the module is static
    var bytes = Uint8Array.of(
      0x00,
      0x61,
      0x73,
      0x6d, // magic ("\0asm")
      0x01,
      0x00,
      0x00,
      0x00, // version: 1
      0x01, // Type section code
      // The module is static, with the exception of the type section, which is
      // generated based on the signature passed in.
      ...uleb128EncodeWithLen([
        0x01, // count: 1
        0x60 /* form: func */,
        // param types
        ...generateTypePack(sig.slice(1)),
        // return types (for now only supporting [] if `void` and single [T] otherwise)
        ...generateTypePack(sig[0] === 'v' ? '' : sig[0]),
      ]),
      // The rest of the module is static
      0x02,
      0x07, // import section
      // (import "e" "f" (func 0 (type 0)))
      0x01,
      0x01,
      0x65,
      0x01,
      0x66,
      0x00,
      0x00,
      0x07,
      0x05, // export section
      // (export "f" (func 0 (type 0)))
      0x01,
      0x01,
      0x66,
      0x00,
      0x00,
    );

    // We can compile this wasm module synchronously because it is very small.
    // This accepts an import (at "e.f"), that it reroutes to an export (at "f")
    var module = new WebAssembly.Module(bytes);
    var instance = new WebAssembly.Instance(module, { e: { f: func } });
    var wrappedFunc = instance.exports['f'];
    return wrappedFunc;
  };
  /** @param {string=} sig */
  var addFunction = (func, sig) => {
    assert(typeof func != 'undefined');
    // Check if the function is already in the table, to ensure each function
    // gets a unique index.
    var rtn = getFunctionAddress(func);
    if (rtn) {
      return rtn;
    }

    // It's not in the table, add it now.

    var ret = getEmptyTableSlot();

    // Set the new value.
    try {
      // Attempting to call this with JS function will cause table.set() to fail
      setWasmTableEntry(ret, func);
    } catch (err) {
      if (!(err instanceof TypeError)) {
        throw err;
      }
      assert(typeof sig != 'undefined', 'Missing signature argument to addFunction: ' + func);
      var wrapped = convertJsFunctionToWasm(func, sig);
      setWasmTableEntry(ret, wrapped);
    }

    functionsInTableMap.set(func, ret);

    return ret;
  };

  // End JS library code

  // include: postlibrary.js
  // This file is included after the automatically-generated JS library code
  // but before the wasm module is created.

  {
    // Begin ATMODULES hooks
    if (Module['noExitRuntime']) noExitRuntime = Module['noExitRuntime'];
    if (Module['print']) out = Module['print'];
    if (Module['printErr']) err = Module['printErr'];
    if (Module['wasmBinary']) wasmBinary = Module['wasmBinary'];

    Module['FS_createDataFile'] = FS.createDataFile;
    Module['FS_createPreloadedFile'] = FS.createPreloadedFile;

    // End ATMODULES hooks

    checkIncomingModuleAPI();

    if (Module['arguments']) arguments_ = Module['arguments'];
    if (Module['thisProgram']) thisProgram = Module['thisProgram'];

    // Assertions on removed incoming Module JS APIs.
    assert(
      typeof Module['memoryInitializerPrefixURL'] == 'undefined',
      'Module.memoryInitializerPrefixURL option was removed, use Module.locateFile instead',
    );
    assert(
      typeof Module['pthreadMainPrefixURL'] == 'undefined',
      'Module.pthreadMainPrefixURL option was removed, use Module.locateFile instead',
    );
    assert(
      typeof Module['cdInitializerPrefixURL'] == 'undefined',
      'Module.cdInitializerPrefixURL option was removed, use Module.locateFile instead',
    );
    assert(
      typeof Module['filePackagePrefixURL'] == 'undefined',
      'Module.filePackagePrefixURL option was removed, use Module.locateFile instead',
    );
    assert(typeof Module['read'] == 'undefined', 'Module.read option was removed');
    assert(
      typeof Module['readAsync'] == 'undefined',
      'Module.readAsync option was removed (modify readAsync in JS)',
    );
    assert(
      typeof Module['readBinary'] == 'undefined',
      'Module.readBinary option was removed (modify readBinary in JS)',
    );
    assert(
      typeof Module['setWindowTitle'] == 'undefined',
      'Module.setWindowTitle option was removed (modify emscripten_set_window_title in JS)',
    );
    assert(
      typeof Module['TOTAL_MEMORY'] == 'undefined',
      'Module.TOTAL_MEMORY has been renamed Module.INITIAL_MEMORY',
    );
    assert(
      typeof Module['ENVIRONMENT'] == 'undefined',
      'Module.ENVIRONMENT has been deprecated. To force the environment, use the ENVIRONMENT compile-time option (for example, -sENVIRONMENT=web or -sENVIRONMENT=node)',
    );
    assert(
      typeof Module['STACK_SIZE'] == 'undefined',
      'STACK_SIZE can no longer be set at runtime.  Use -sSTACK_SIZE at link time',
    );
    // If memory is defined in wasm, the user can't provide it, or set INITIAL_MEMORY
    assert(
      typeof Module['wasmMemory'] == 'undefined',
      'Use of `wasmMemory` detected.  Use -sIMPORTED_MEMORY to define wasmMemory externally',
    );
    assert(
      typeof Module['INITIAL_MEMORY'] == 'undefined',
      'Detected runtime INITIAL_MEMORY setting.  Use -sIMPORTED_MEMORY to define wasmMemory dynamically',
    );

    if (Module['preInit']) {
      if (typeof Module['preInit'] == 'function') Module['preInit'] = [Module['preInit']];
      while (Module['preInit'].length > 0) {
        Module['preInit'].shift()();
      }
    }
    consumedModuleProp('preInit');
  }

  // Begin runtime exports
  Module['addFunction'] = addFunction;
  Module['Asyncify'] = Asyncify;
  var missingLibrarySymbols = [
    'writeI53ToI64',
    'writeI53ToI64Clamped',
    'writeI53ToI64Signaling',
    'writeI53ToU64Clamped',
    'writeI53ToU64Signaling',
    'readI53FromI64',
    'readI53FromU64',
    'convertI32PairToI53',
    'convertI32PairToI53Checked',
    'convertU32PairToI53',
    'stackAlloc',
    'getTempRet0',
    'setTempRet0',
    'zeroMemory',
    'withStackSave',
    'strError',
    'inetPton4',
    'inetNtop4',
    'inetPton6',
    'inetNtop6',
    'readSockaddr',
    'writeSockaddr',
    'readEmAsmArgs',
    'jstoi_q',
    'autoResumeAudioContext',
    'getDynCaller',
    'asyncLoad',
    'asmjsMangle',
    'mmapAlloc',
    'HandleAllocator',
    'getUniqueRunDependency',
    'addRunDependency',
    'removeRunDependency',
    'addOnInit',
    'addOnPostCtor',
    'addOnPreMain',
    'addOnExit',
    'STACK_SIZE',
    'STACK_ALIGN',
    'POINTER_SIZE',
    'ASSERTIONS',
    'ccall',
    'cwrap',
    'removeFunction',
    'intArrayFromString',
    'intArrayToString',
    'AsciiToString',
    'stringToAscii',
    'UTF16ToString',
    'stringToUTF16',
    'lengthBytesUTF16',
    'UTF32ToString',
    'stringToUTF32',
    'lengthBytesUTF32',
    'stringToNewUTF8',
    'stringToUTF8OnStack',
    'writeArrayToMemory',
    'registerKeyEventCallback',
    'maybeCStringToJsString',
    'findEventTarget',
    'getBoundingClientRect',
    'fillMouseEventData',
    'registerMouseEventCallback',
    'registerWheelEventCallback',
    'registerUiEventCallback',
    'registerFocusEventCallback',
    'fillDeviceOrientationEventData',
    'registerDeviceOrientationEventCallback',
    'fillDeviceMotionEventData',
    'registerDeviceMotionEventCallback',
    'screenOrientation',
    'fillOrientationChangeEventData',
    'registerOrientationChangeEventCallback',
    'fillFullscreenChangeEventData',
    'registerFullscreenChangeEventCallback',
    'JSEvents_requestFullscreen',
    'JSEvents_resizeCanvasForFullscreen',
    'registerRestoreOldStyle',
    'hideEverythingExceptGivenElement',
    'restoreHiddenElements',
    'setLetterbox',
    'softFullscreenResizeWebGLRenderTarget',
    'doRequestFullscreen',
    'fillPointerlockChangeEventData',
    'registerPointerlockChangeEventCallback',
    'registerPointerlockErrorEventCallback',
    'requestPointerLock',
    'fillVisibilityChangeEventData',
    'registerVisibilityChangeEventCallback',
    'registerTouchEventCallback',
    'fillGamepadEventData',
    'registerGamepadEventCallback',
    'registerBeforeUnloadEventCallback',
    'fillBatteryEventData',
    'registerBatteryEventCallback',
    'setCanvasElementSize',
    'getCanvasElementSize',
    'jsStackTrace',
    'getCallstack',
    'convertPCtoSourceLocation',
    'checkWasiClock',
    'wasiRightsToMuslOFlags',
    'wasiOFlagsToMuslOFlags',
    'initRandomFill',
    'randomFill',
    'safeSetTimeout',
    'setImmediateWrapped',
    'safeRequestAnimationFrame',
    'clearImmediateWrapped',
    'registerPostMainLoop',
    'registerPreMainLoop',
    'getPromise',
    'makePromise',
    'idsToPromises',
    'makePromiseCallback',
    'ExceptionInfo',
    'findMatchingCatch',
    'Browser_asyncPrepareDataCounter',
    'isLeapYear',
    'ydayFromDate',
    'arraySum',
    'addDays',
    'getSocketFromFD',
    'getSocketAddress',
    'heapObjectForWebGLType',
    'toTypedArrayIndex',
    'webgl_enable_ANGLE_instanced_arrays',
    'webgl_enable_OES_vertex_array_object',
    'webgl_enable_WEBGL_draw_buffers',
    'webgl_enable_WEBGL_multi_draw',
    'webgl_enable_EXT_polygon_offset_clamp',
    'webgl_enable_EXT_clip_control',
    'webgl_enable_WEBGL_polygon_mode',
    'emscriptenWebGLGet',
    'computeUnpackAlignedImageSize',
    'colorChannelsInGlTextureFormat',
    'emscriptenWebGLGetTexPixelData',
    'emscriptenWebGLGetUniform',
    'webglGetUniformLocation',
    'webglPrepareUniformLocationsBeforeFirstUse',
    'webglGetLeftBracePos',
    'emscriptenWebGLGetVertexAttrib',
    '__glGetActiveAttribOrUniform',
    'writeGLArray',
    'registerWebGlEventCallback',
    'ALLOC_NORMAL',
    'ALLOC_STACK',
    'allocate',
    'writeStringToMemory',
    'writeAsciiToMemory',
    'allocateUTF8',
    'allocateUTF8OnStack',
    'demangle',
    'stackTrace',
    'getNativeTypeSize',
  ];
  missingLibrarySymbols.forEach(missingLibrarySymbol);

  var unexportedSymbols = [
    'run',
    'out',
    'err',
    'callMain',
    'abort',
    'wasmExports',
    'HEAP64',
    'HEAPU64',
    'writeStackCookie',
    'checkStackCookie',
    'INT53_MAX',
    'INT53_MIN',
    'bigintToI53Checked',
    'stackSave',
    'stackRestore',
    'createNamedFunction',
    'ptrToString',
    'exitJS',
    'getHeapMax',
    'growMemory',
    'ENV',
    'setStackLimits',
    'ERRNO_CODES',
    'DNS',
    'Protocols',
    'Sockets',
    'timers',
    'warnOnce',
    'readEmAsmArgsArray',
    'getExecutableName',
    'dynCallLegacy',
    'dynCall',
    'handleException',
    'keepRuntimeAlive',
    'runtimeKeepalivePush',
    'runtimeKeepalivePop',
    'callUserCallback',
    'maybeExit',
    'alignMemory',
    'wasmTable',
    'wasmMemory',
    'noExitRuntime',
    'addOnPreRun',
    'addOnPostRun',
    'convertJsFunctionToWasm',
    'freeTableIndexes',
    'functionsInTableMap',
    'getEmptyTableSlot',
    'updateTableMap',
    'getFunctionAddress',
    'setValue',
    'getValue',
    'PATH',
    'PATH_FS',
    'UTF8Decoder',
    'UTF8ArrayToString',
    'UTF8ToString',
    'stringToUTF8Array',
    'stringToUTF8',
    'lengthBytesUTF8',
    'UTF16Decoder',
    'JSEvents',
    'specialHTMLTargets',
    'findCanvasEventTarget',
    'currentFullscreenStrategy',
    'restoreOldWindowedStyle',
    'UNWIND_CACHE',
    'ExitStatus',
    'getEnvStrings',
    'flush_NO_FILESYSTEM',
    'emSetImmediate',
    'emClearImmediate_deps',
    'emClearImmediate',
    'promiseMap',
    'uncaughtExceptionCount',
    'exceptionLast',
    'exceptionCaught',
    'Browser',
    'requestFullscreen',
    'requestFullScreen',
    'setCanvasSize',
    'getUserMedia',
    'createContext',
    'getPreloadedImageData__data',
    'wget',
    'MONTH_DAYS_REGULAR',
    'MONTH_DAYS_LEAP',
    'MONTH_DAYS_REGULAR_CUMULATIVE',
    'MONTH_DAYS_LEAP_CUMULATIVE',
    'SYSCALLS',
    'tempFixedLengthArray',
    'miniTempWebGLFloatBuffers',
    'miniTempWebGLIntBuffers',
    'GL',
    'AL',
    'GLUT',
    'EGL',
    'GLEW',
    'IDBStore',
    'runAndAbortIfError',
    'Fibers',
    'SDL',
    'SDL_gfx',
    'print',
    'printErr',
    'jstoi_s',
  ];
  unexportedSymbols.forEach(unexportedRuntimeSymbol);

  // End runtime exports
  // Begin JS library exports
  // End JS library exports

  // end include: postlibrary.js

  function checkIncomingModuleAPI() {
    ignoredModuleProp('fetchSettings');
    ignoredModuleProp('logReadFiles');
    ignoredModuleProp('loadSplitModule');
  }

  // Imports from the Wasm binary.
  var ___asan_default_options = (Module['___asan_default_options'] =
    makeInvalidEarlyAccess('___asan_default_options'));
  var _init = (Module['_init'] = makeInvalidEarlyAccess('_init'));
  var _dispose = (Module['_dispose'] = makeInvalidEarlyAccess('_dispose'));
  var _getVersion = (Module['_getVersion'] = makeInvalidEarlyAccess('_getVersion'));
  var _setErrorCallback = (Module['_setErrorCallback'] =
    makeInvalidEarlyAccess('_setErrorCallback'));
  var _getMainDesc = (Module['_getMainDesc'] = makeInvalidEarlyAccess('_getMainDesc'));
  var _getWindowsChangedState = (Module['_getWindowsChangedState'] =
    makeInvalidEarlyAccess('_getWindowsChangedState'));
  var _getVarsDesc = (Module['_getVarsDesc'] = makeInvalidEarlyAccess('_getVarsDesc'));
  var _getActions = (Module['_getActions'] = makeInvalidEarlyAccess('_getActions'));
  var _malloc = (Module['_malloc'] = makeInvalidEarlyAccess('_malloc'));
  var _selectAction = (Module['_selectAction'] = makeInvalidEarlyAccess('_selectAction'));
  var _executeSelAction = (Module['_executeSelAction'] =
    makeInvalidEarlyAccess('_executeSelAction'));
  var _getObjects = (Module['_getObjects'] = makeInvalidEarlyAccess('_getObjects'));
  var _selectObject = (Module['_selectObject'] = makeInvalidEarlyAccess('_selectObject'));
  var _loadGameData = (Module['_loadGameData'] = makeInvalidEarlyAccess('_loadGameData'));
  var _restartGame = (Module['_restartGame'] = makeInvalidEarlyAccess('_restartGame'));
  var _saveGameData = (Module['_saveGameData'] = makeInvalidEarlyAccess('_saveGameData'));
  var _free = (Module['_free'] = makeInvalidEarlyAccess('_free'));
  var _loadSavedGameData = (Module['_loadSavedGameData'] =
    makeInvalidEarlyAccess('_loadSavedGameData'));
  var _execString = (Module['_execString'] = makeInvalidEarlyAccess('_execString'));
  var _execCounter = (Module['_execCounter'] = makeInvalidEarlyAccess('_execCounter'));
  var _execLoc = (Module['_execLoc'] = makeInvalidEarlyAccess('_execLoc'));
  var _execUserInput = (Module['_execUserInput'] = makeInvalidEarlyAccess('_execUserInput'));
  var _getLastError = (Module['_getLastError'] = makeInvalidEarlyAccess('_getLastError'));
  var _getVarValue = (Module['_getVarValue'] = makeInvalidEarlyAccess('_getVarValue'));
  var _getVarValueByIndex = (Module['_getVarValueByIndex'] =
    makeInvalidEarlyAccess('_getVarValueByIndex'));
  var _getVarValueByKey = (Module['_getVarValueByKey'] =
    makeInvalidEarlyAccess('_getVarValueByKey'));
  var _getVarSize = (Module['_getVarSize'] = makeInvalidEarlyAccess('_getVarSize'));
  var _setCallback = (Module['_setCallback'] = makeInvalidEarlyAccess('_setCallback'));
  var _freeItemsList = (Module['_freeItemsList'] = makeInvalidEarlyAccess('_freeItemsList'));
  var _freeObjectsList = (Module['_freeObjectsList'] = makeInvalidEarlyAccess('_freeObjectsList'));
  var _freeSaveBuffer = (Module['_freeSaveBuffer'] = makeInvalidEarlyAccess('_freeSaveBuffer'));
  var _freeStringsBuffer = (Module['_freeStringsBuffer'] =
    makeInvalidEarlyAccess('_freeStringsBuffer'));
  var _enableDebugMode = (Module['_enableDebugMode'] = makeInvalidEarlyAccess('_enableDebugMode'));
  var _disableDebugMode = (Module['_disableDebugMode'] =
    makeInvalidEarlyAccess('_disableDebugMode'));
  var _getCurStateData = (Module['_getCurStateData'] = makeInvalidEarlyAccess('_getCurStateData'));
  var _getLocationsList = (Module['_getLocationsList'] =
    makeInvalidEarlyAccess('_getLocationsList'));
  var _getLocationActions = (Module['_getLocationActions'] =
    makeInvalidEarlyAccess('_getLocationActions'));
  var _getLocationCode = (Module['_getLocationCode'] = makeInvalidEarlyAccess('_getLocationCode'));
  var _getActionCode = (Module['_getActionCode'] = makeInvalidEarlyAccess('_getActionCode'));
  var _calculateStrExpression = (Module['_calculateStrExpression'] =
    makeInvalidEarlyAccess('_calculateStrExpression'));
  var _calculateNumExpression = (Module['_calculateNumExpression'] =
    makeInvalidEarlyAccess('_calculateNumExpression'));
  var _showWindow = (Module['_showWindow'] = makeInvalidEarlyAccess('_showWindow'));
  var _getSelActionIndex = (Module['_getSelActionIndex'] =
    makeInvalidEarlyAccess('_getSelActionIndex'));
  var _getSelObjectIndex = (Module['_getSelObjectIndex'] =
    makeInvalidEarlyAccess('_getSelObjectIndex'));
  var _getCompiledDateTime = (Module['_getCompiledDateTime'] =
    makeInvalidEarlyAccess('_getCompiledDateTime'));
  var _getErrorDesc = (Module['_getErrorDesc'] = makeInvalidEarlyAccess('_getErrorDesc'));
  var _getLocationDesc = (Module['_getLocationDesc'] = makeInvalidEarlyAccess('_getLocationDesc'));
  var __run_checks = (Module['__run_checks'] = makeInvalidEarlyAccess('__run_checks'));
  var _fflush = makeInvalidEarlyAccess('_fflush');
  var _emscripten_stack_get_end = makeInvalidEarlyAccess('_emscripten_stack_get_end');
  var _emscripten_stack_get_base = makeInvalidEarlyAccess('_emscripten_stack_get_base');
  var _emscripten_stack_init = makeInvalidEarlyAccess('_emscripten_stack_init');
  var _emscripten_stack_get_free = makeInvalidEarlyAccess('_emscripten_stack_get_free');
  var __emscripten_stack_restore = makeInvalidEarlyAccess('__emscripten_stack_restore');
  var __emscripten_stack_alloc = makeInvalidEarlyAccess('__emscripten_stack_alloc');
  var _emscripten_stack_get_current = makeInvalidEarlyAccess('_emscripten_stack_get_current');
  var ___set_stack_limits = (Module['___set_stack_limits'] =
    makeInvalidEarlyAccess('___set_stack_limits'));
  var dynCall_iii = makeInvalidEarlyAccess('dynCall_iii');
  var dynCall_viii = makeInvalidEarlyAccess('dynCall_viii');
  var dynCall_vi = makeInvalidEarlyAccess('dynCall_vi');
  var dynCall_iiii = makeInvalidEarlyAccess('dynCall_iiii');
  var dynCall_iiiii = makeInvalidEarlyAccess('dynCall_iiiii');
  var dynCall_ii = makeInvalidEarlyAccess('dynCall_ii');
  var dynCall_i = makeInvalidEarlyAccess('dynCall_i');
  var dynCall_jiji = makeInvalidEarlyAccess('dynCall_jiji');
  var dynCall_iidiiii = makeInvalidEarlyAccess('dynCall_iidiiii');
  var dynCall_vii = makeInvalidEarlyAccess('dynCall_vii');
  var _asyncify_start_unwind = makeInvalidEarlyAccess('_asyncify_start_unwind');
  var _asyncify_stop_unwind = makeInvalidEarlyAccess('_asyncify_stop_unwind');
  var _asyncify_start_rewind = makeInvalidEarlyAccess('_asyncify_start_rewind');
  var _asyncify_stop_rewind = makeInvalidEarlyAccess('_asyncify_stop_rewind');
  var memory = makeInvalidEarlyAccess('memory');
  var __indirect_function_table = makeInvalidEarlyAccess('__indirect_function_table');
  var wasmMemory = makeInvalidEarlyAccess('wasmMemory');
  var wasmTable = makeInvalidEarlyAccess('wasmTable');

  function assignWasmExports(wasmExports) {
    assert(
      typeof wasmExports['__asan_default_options'] != 'undefined',
      'missing Wasm export: __asan_default_options',
    );
    assert(typeof wasmExports['init'] != 'undefined', 'missing Wasm export: init');
    assert(typeof wasmExports['dispose'] != 'undefined', 'missing Wasm export: dispose');
    assert(typeof wasmExports['getVersion'] != 'undefined', 'missing Wasm export: getVersion');
    assert(
      typeof wasmExports['setErrorCallback'] != 'undefined',
      'missing Wasm export: setErrorCallback',
    );
    assert(typeof wasmExports['getMainDesc'] != 'undefined', 'missing Wasm export: getMainDesc');
    assert(
      typeof wasmExports['getWindowsChangedState'] != 'undefined',
      'missing Wasm export: getWindowsChangedState',
    );
    assert(typeof wasmExports['getVarsDesc'] != 'undefined', 'missing Wasm export: getVarsDesc');
    assert(typeof wasmExports['getActions'] != 'undefined', 'missing Wasm export: getActions');
    assert(typeof wasmExports['malloc'] != 'undefined', 'missing Wasm export: malloc');
    assert(typeof wasmExports['selectAction'] != 'undefined', 'missing Wasm export: selectAction');
    assert(
      typeof wasmExports['executeSelAction'] != 'undefined',
      'missing Wasm export: executeSelAction',
    );
    assert(typeof wasmExports['getObjects'] != 'undefined', 'missing Wasm export: getObjects');
    assert(typeof wasmExports['selectObject'] != 'undefined', 'missing Wasm export: selectObject');
    assert(typeof wasmExports['loadGameData'] != 'undefined', 'missing Wasm export: loadGameData');
    assert(typeof wasmExports['restartGame'] != 'undefined', 'missing Wasm export: restartGame');
    assert(typeof wasmExports['saveGameData'] != 'undefined', 'missing Wasm export: saveGameData');
    assert(typeof wasmExports['free'] != 'undefined', 'missing Wasm export: free');
    assert(
      typeof wasmExports['loadSavedGameData'] != 'undefined',
      'missing Wasm export: loadSavedGameData',
    );
    assert(typeof wasmExports['execString'] != 'undefined', 'missing Wasm export: execString');
    assert(typeof wasmExports['execCounter'] != 'undefined', 'missing Wasm export: execCounter');
    assert(typeof wasmExports['execLoc'] != 'undefined', 'missing Wasm export: execLoc');
    assert(
      typeof wasmExports['execUserInput'] != 'undefined',
      'missing Wasm export: execUserInput',
    );
    assert(typeof wasmExports['getLastError'] != 'undefined', 'missing Wasm export: getLastError');
    assert(typeof wasmExports['getVarValue'] != 'undefined', 'missing Wasm export: getVarValue');
    assert(
      typeof wasmExports['getVarValueByIndex'] != 'undefined',
      'missing Wasm export: getVarValueByIndex',
    );
    assert(
      typeof wasmExports['getVarValueByKey'] != 'undefined',
      'missing Wasm export: getVarValueByKey',
    );
    assert(typeof wasmExports['getVarSize'] != 'undefined', 'missing Wasm export: getVarSize');
    assert(typeof wasmExports['setCallback'] != 'undefined', 'missing Wasm export: setCallback');
    assert(
      typeof wasmExports['freeItemsList'] != 'undefined',
      'missing Wasm export: freeItemsList',
    );
    assert(
      typeof wasmExports['freeObjectsList'] != 'undefined',
      'missing Wasm export: freeObjectsList',
    );
    assert(
      typeof wasmExports['freeSaveBuffer'] != 'undefined',
      'missing Wasm export: freeSaveBuffer',
    );
    assert(
      typeof wasmExports['freeStringsBuffer'] != 'undefined',
      'missing Wasm export: freeStringsBuffer',
    );
    assert(
      typeof wasmExports['enableDebugMode'] != 'undefined',
      'missing Wasm export: enableDebugMode',
    );
    assert(
      typeof wasmExports['disableDebugMode'] != 'undefined',
      'missing Wasm export: disableDebugMode',
    );
    assert(
      typeof wasmExports['getCurStateData'] != 'undefined',
      'missing Wasm export: getCurStateData',
    );
    assert(
      typeof wasmExports['getLocationsList'] != 'undefined',
      'missing Wasm export: getLocationsList',
    );
    assert(
      typeof wasmExports['getLocationActions'] != 'undefined',
      'missing Wasm export: getLocationActions',
    );
    assert(
      typeof wasmExports['getLocationCode'] != 'undefined',
      'missing Wasm export: getLocationCode',
    );
    assert(
      typeof wasmExports['getActionCode'] != 'undefined',
      'missing Wasm export: getActionCode',
    );
    assert(
      typeof wasmExports['calculateStrExpression'] != 'undefined',
      'missing Wasm export: calculateStrExpression',
    );
    assert(
      typeof wasmExports['calculateNumExpression'] != 'undefined',
      'missing Wasm export: calculateNumExpression',
    );
    assert(typeof wasmExports['showWindow'] != 'undefined', 'missing Wasm export: showWindow');
    assert(
      typeof wasmExports['getSelActionIndex'] != 'undefined',
      'missing Wasm export: getSelActionIndex',
    );
    assert(
      typeof wasmExports['getSelObjectIndex'] != 'undefined',
      'missing Wasm export: getSelObjectIndex',
    );
    assert(
      typeof wasmExports['getCompiledDateTime'] != 'undefined',
      'missing Wasm export: getCompiledDateTime',
    );
    assert(typeof wasmExports['getErrorDesc'] != 'undefined', 'missing Wasm export: getErrorDesc');
    assert(
      typeof wasmExports['getLocationDesc'] != 'undefined',
      'missing Wasm export: getLocationDesc',
    );
    assert(typeof wasmExports['_run_checks'] != 'undefined', 'missing Wasm export: _run_checks');
    assert(typeof wasmExports['fflush'] != 'undefined', 'missing Wasm export: fflush');
    assert(
      typeof wasmExports['emscripten_stack_get_end'] != 'undefined',
      'missing Wasm export: emscripten_stack_get_end',
    );
    assert(
      typeof wasmExports['emscripten_stack_get_base'] != 'undefined',
      'missing Wasm export: emscripten_stack_get_base',
    );
    assert(
      typeof wasmExports['emscripten_stack_init'] != 'undefined',
      'missing Wasm export: emscripten_stack_init',
    );
    assert(
      typeof wasmExports['emscripten_stack_get_free'] != 'undefined',
      'missing Wasm export: emscripten_stack_get_free',
    );
    assert(
      typeof wasmExports['_emscripten_stack_restore'] != 'undefined',
      'missing Wasm export: _emscripten_stack_restore',
    );
    assert(
      typeof wasmExports['_emscripten_stack_alloc'] != 'undefined',
      'missing Wasm export: _emscripten_stack_alloc',
    );
    assert(
      typeof wasmExports['emscripten_stack_get_current'] != 'undefined',
      'missing Wasm export: emscripten_stack_get_current',
    );
    assert(
      typeof wasmExports['__set_stack_limits'] != 'undefined',
      'missing Wasm export: __set_stack_limits',
    );
    assert(typeof wasmExports['dynCall_iii'] != 'undefined', 'missing Wasm export: dynCall_iii');
    assert(typeof wasmExports['dynCall_viii'] != 'undefined', 'missing Wasm export: dynCall_viii');
    assert(typeof wasmExports['dynCall_vi'] != 'undefined', 'missing Wasm export: dynCall_vi');
    assert(typeof wasmExports['dynCall_iiii'] != 'undefined', 'missing Wasm export: dynCall_iiii');
    assert(
      typeof wasmExports['dynCall_iiiii'] != 'undefined',
      'missing Wasm export: dynCall_iiiii',
    );
    assert(typeof wasmExports['dynCall_ii'] != 'undefined', 'missing Wasm export: dynCall_ii');
    assert(typeof wasmExports['dynCall_i'] != 'undefined', 'missing Wasm export: dynCall_i');
    assert(typeof wasmExports['dynCall_jiji'] != 'undefined', 'missing Wasm export: dynCall_jiji');
    assert(
      typeof wasmExports['dynCall_iidiiii'] != 'undefined',
      'missing Wasm export: dynCall_iidiiii',
    );
    assert(typeof wasmExports['dynCall_vii'] != 'undefined', 'missing Wasm export: dynCall_vii');
    assert(
      typeof wasmExports['asyncify_start_unwind'] != 'undefined',
      'missing Wasm export: asyncify_start_unwind',
    );
    assert(
      typeof wasmExports['asyncify_stop_unwind'] != 'undefined',
      'missing Wasm export: asyncify_stop_unwind',
    );
    assert(
      typeof wasmExports['asyncify_start_rewind'] != 'undefined',
      'missing Wasm export: asyncify_start_rewind',
    );
    assert(
      typeof wasmExports['asyncify_stop_rewind'] != 'undefined',
      'missing Wasm export: asyncify_stop_rewind',
    );
    assert(typeof wasmExports['memory'] != 'undefined', 'missing Wasm export: memory');
    assert(
      typeof wasmExports['__indirect_function_table'] != 'undefined',
      'missing Wasm export: __indirect_function_table',
    );
    ___asan_default_options = Module['___asan_default_options'] =
      wasmExports['__asan_default_options'];
    _init = Module['_init'] = createExportWrapper('init', 0);
    _dispose = Module['_dispose'] = createExportWrapper('dispose', 0);
    _getVersion = Module['_getVersion'] = createExportWrapper('getVersion', 1);
    _setErrorCallback = Module['_setErrorCallback'] = createExportWrapper('setErrorCallback', 1);
    _getMainDesc = Module['_getMainDesc'] = createExportWrapper('getMainDesc', 1);
    _getWindowsChangedState = Module['_getWindowsChangedState'] = createExportWrapper(
      'getWindowsChangedState',
      0,
    );
    _getVarsDesc = Module['_getVarsDesc'] = createExportWrapper('getVarsDesc', 1);
    _getActions = Module['_getActions'] = createExportWrapper('getActions', 1);
    _malloc = Module['_malloc'] = createExportWrapper('malloc', 1);
    _selectAction = Module['_selectAction'] = createExportWrapper('selectAction', 1);
    _executeSelAction = Module['_executeSelAction'] = createExportWrapper('executeSelAction', 0);
    _getObjects = Module['_getObjects'] = createExportWrapper('getObjects', 1);
    _selectObject = Module['_selectObject'] = createExportWrapper('selectObject', 1);
    _loadGameData = Module['_loadGameData'] = createExportWrapper('loadGameData', 3);
    _restartGame = Module['_restartGame'] = createExportWrapper('restartGame', 0);
    _saveGameData = Module['_saveGameData'] = createExportWrapper('saveGameData', 1);
    _free = Module['_free'] = createExportWrapper('free', 1);
    _loadSavedGameData = Module['_loadSavedGameData'] = createExportWrapper('loadSavedGameData', 2);
    _execString = Module['_execString'] = createExportWrapper('execString', 2);
    _execCounter = Module['_execCounter'] = createExportWrapper('execCounter', 0);
    _execLoc = Module['_execLoc'] = createExportWrapper('execLoc', 1);
    _execUserInput = Module['_execUserInput'] = createExportWrapper('execUserInput', 1);
    _getLastError = Module['_getLastError'] = createExportWrapper('getLastError', 1);
    _getVarValue = Module['_getVarValue'] = createExportWrapper('getVarValue', 2);
    _getVarValueByIndex = Module['_getVarValueByIndex'] = createExportWrapper(
      'getVarValueByIndex',
      3,
    );
    _getVarValueByKey = Module['_getVarValueByKey'] = createExportWrapper('getVarValueByKey', 3);
    _getVarSize = Module['_getVarSize'] = createExportWrapper('getVarSize', 1);
    _setCallback = Module['_setCallback'] = createExportWrapper('setCallback', 2);
    _freeItemsList = Module['_freeItemsList'] = createExportWrapper('freeItemsList', 1);
    _freeObjectsList = Module['_freeObjectsList'] = createExportWrapper('freeObjectsList', 1);
    _freeSaveBuffer = Module['_freeSaveBuffer'] = createExportWrapper('freeSaveBuffer', 1);
    _freeStringsBuffer = Module['_freeStringsBuffer'] = createExportWrapper('freeStringsBuffer', 1);
    _enableDebugMode = Module['_enableDebugMode'] = createExportWrapper('enableDebugMode', 0);
    _disableDebugMode = Module['_disableDebugMode'] = createExportWrapper('disableDebugMode', 0);
    _getCurStateData = Module['_getCurStateData'] = createExportWrapper('getCurStateData', 3);
    _getLocationsList = Module['_getLocationsList'] = createExportWrapper('getLocationsList', 1);
    _getLocationActions = Module['_getLocationActions'] = createExportWrapper(
      'getLocationActions',
      2,
    );
    _getLocationCode = Module['_getLocationCode'] = createExportWrapper('getLocationCode', 2);
    _getActionCode = Module['_getActionCode'] = createExportWrapper('getActionCode', 3);
    _calculateStrExpression = Module['_calculateStrExpression'] = createExportWrapper(
      'calculateStrExpression',
      2,
    );
    _calculateNumExpression = Module['_calculateNumExpression'] = createExportWrapper(
      'calculateNumExpression',
      2,
    );
    _showWindow = Module['_showWindow'] = createExportWrapper('showWindow', 2);
    _getSelActionIndex = Module['_getSelActionIndex'] = createExportWrapper('getSelActionIndex', 0);
    _getSelObjectIndex = Module['_getSelObjectIndex'] = createExportWrapper('getSelObjectIndex', 0);
    _getCompiledDateTime = Module['_getCompiledDateTime'] = createExportWrapper(
      'getCompiledDateTime',
      1,
    );
    _getErrorDesc = Module['_getErrorDesc'] = createExportWrapper('getErrorDesc', 2);
    _getLocationDesc = Module['_getLocationDesc'] = createExportWrapper('getLocationDesc', 2);
    __run_checks = Module['__run_checks'] = createExportWrapper('_run_checks', 0);
    _fflush = createExportWrapper('fflush', 1);
    _emscripten_stack_get_end = wasmExports['emscripten_stack_get_end'];
    _emscripten_stack_get_base = wasmExports['emscripten_stack_get_base'];
    _emscripten_stack_init = wasmExports['emscripten_stack_init'];
    _emscripten_stack_get_free = wasmExports['emscripten_stack_get_free'];
    __emscripten_stack_restore = wasmExports['_emscripten_stack_restore'];
    __emscripten_stack_alloc = wasmExports['_emscripten_stack_alloc'];
    _emscripten_stack_get_current = wasmExports['emscripten_stack_get_current'];
    ___set_stack_limits = Module['___set_stack_limits'] = createExportWrapper(
      '__set_stack_limits',
      2,
    );
    dynCall_iii = dynCalls['iii'] = createExportWrapper('dynCall_iii', 3);
    dynCall_viii = dynCalls['viii'] = createExportWrapper('dynCall_viii', 4);
    dynCall_vi = dynCalls['vi'] = createExportWrapper('dynCall_vi', 2);
    dynCall_iiii = dynCalls['iiii'] = createExportWrapper('dynCall_iiii', 4);
    dynCall_iiiii = dynCalls['iiiii'] = createExportWrapper('dynCall_iiiii', 5);
    dynCall_ii = dynCalls['ii'] = createExportWrapper('dynCall_ii', 2);
    dynCall_i = dynCalls['i'] = createExportWrapper('dynCall_i', 1);
    dynCall_jiji = dynCalls['jiji'] = createExportWrapper('dynCall_jiji', 4);
    dynCall_iidiiii = dynCalls['iidiiii'] = createExportWrapper('dynCall_iidiiii', 7);
    dynCall_vii = dynCalls['vii'] = createExportWrapper('dynCall_vii', 3);
    _asyncify_start_unwind = createExportWrapper('asyncify_start_unwind', 1);
    _asyncify_stop_unwind = createExportWrapper('asyncify_stop_unwind', 0);
    _asyncify_start_rewind = createExportWrapper('asyncify_start_rewind', 1);
    _asyncify_stop_rewind = createExportWrapper('asyncify_stop_rewind', 0);
    memory = wasmMemory = wasmExports['memory'];
    __indirect_function_table = wasmTable = wasmExports['__indirect_function_table'];
  }

  var wasmImports = {
    /** @export */
    __handle_stack_overflow: ___handle_stack_overflow,
    /** @export */
    _abort_js: __abort_js,
    /** @export */
    emscripten_date_now: _emscripten_date_now,
    /** @export */
    emscripten_resize_heap: _emscripten_resize_heap,
    /** @export */
    environ_get: _environ_get,
    /** @export */
    environ_sizes_get: _environ_sizes_get,
    /** @export */
    fd_close: _fd_close,
    /** @export */
    fd_seek: _fd_seek,
    /** @export */
    fd_write: _fd_write,
  };

  // include: postamble.js
  // === Auto-generated postamble setup entry stuff ===

  var calledRun;

  function stackCheckInit() {
    // This is normally called automatically during __wasm_call_ctors but need to
    // get these values before even running any of the ctors so we call it redundantly
    // here.
    _emscripten_stack_init();
    // TODO(sbc): Move writeStackCookie to native to to avoid this.
    writeStackCookie();
  }

  function run() {
    stackCheckInit();

    preRun();

    function doRun() {
      // run may have just been called through dependencies being fulfilled just in this very frame,
      // or while the async setStatus time below was happening
      assert(!calledRun);
      calledRun = true;
      Module['calledRun'] = true;

      if (ABORT) return;

      initRuntime();

      readyPromiseResolve?.(Module);
      Module['onRuntimeInitialized']?.();
      consumedModuleProp('onRuntimeInitialized');

      assert(
        !Module['_main'],
        'compiled without a main, but one is present. if you added it from JS, use Module["onRuntimeInitialized"]',
      );

      postRun();
    }

    if (Module['setStatus']) {
      Module['setStatus']('Running...');
      setTimeout(() => {
        setTimeout(() => Module['setStatus'](''), 1);
        doRun();
      }, 1);
    } else {
      doRun();
    }
    checkStackCookie();
  }

  function checkUnflushedContent() {
    // Compiler settings do not allow exiting the runtime, so flushing
    // the streams is not possible. but in ASSERTIONS mode we check
    // if there was something to flush, and if so tell the user they
    // should request that the runtime be exitable.
    // Normally we would not even include flush() at all, but in ASSERTIONS
    // builds we do so just for this check, and here we see if there is any
    // content to flush, that is, we check if there would have been
    // something a non-ASSERTIONS build would have not seen.
    // How we flush the streams depends on whether we are in SYSCALLS_REQUIRE_FILESYSTEM=0
    // mode (which has its own special function for this; otherwise, all
    // the code is inside libc)
    var oldOut = out;
    var oldErr = err;
    var has = false;
    out = err = (x) => {
      has = true;
    };
    try {
      // it doesn't matter if it fails
      flush_NO_FILESYSTEM();
    } catch (e) {}
    out = oldOut;
    err = oldErr;
    if (has) {
      warnOnce(
        'stdio streams had content in them that was not flushed. you should set EXIT_RUNTIME to 1 (see the Emscripten FAQ), or make sure to emit a newline when you printf etc.',
      );
      warnOnce(
        '(this may also be due to not including full filesystem support - try building with -sFORCE_FILESYSTEM)',
      );
    }
  }

  var wasmExports;

  // In modularize mode the generated code is within a factory function so we
  // can use await here (since it's not top-level-await).
  wasmExports = await createWasm();

  run();

  // end include: postamble.js

  // include: postamble_modularize.js
  // In MODULARIZE mode we wrap the generated code in a factory function
  // and return either the Module itself, or a promise of the module.
  //
  // We assign to the `moduleRtn` global here and configure closure to see
  // this as an extern so it won't get minified.

  if (runtimeInitialized) {
    moduleRtn = Module;
  } else {
    // Set up the promise that indicates the Module is initialized
    moduleRtn = new Promise((resolve, reject) => {
      readyPromiseResolve = resolve;
      readyPromiseReject = reject;
    });
  }

  // Assertion for attempting to access module properties on the incoming
  // moduleArg.  In the past we used this object as the prototype of the module
  // and assigned properties to it, but now we return a distinct object.  This
  // keeps the instance private until it is ready (i.e the promise has been
  // resolved).
  for (const prop of Object.keys(Module)) {
    if (!(prop in moduleArg)) {
      Object.defineProperty(moduleArg, prop, {
        configurable: true,
        get() {
          abort(
            `Access to module property ('${prop}') is no longer possible via the module constructor argument; Instead, use the result of the module constructor.`,
          );
        },
      });
    }
  }
  // end include: postamble_modularize.js

  return moduleRtn;
}

// Export using a UMD style export, or ES6 exports if selected
export default createQspModule;
